// Recommendation data distilled from PLAN.md.
// Each agent/project keeps a direct URL so the report can render them as
// clickable cards.

// ── Data freshness ─────────────────────────────────────────────────────────
// Single source of truth for "as of when did we last fully verify the report
// data?". The /refresh-aduhelper-data skill bumps this on every full pass.
// Individual entries can override via a `verifiedAt: 'YYYY-MM-DD'` field
// when only that entry was refreshed.
export const DATA_AS_OF = '2026-06-10'

export function getVerifiedAt(entry) {
    return (entry && entry.verifiedAt) || DATA_AS_OF
}

export const AGENTS = {
    // ── 通用对话 / 研究 ─────────────────────────────
    claude:     { name: 'Claude (Fable 5)', org: 'Anthropic', rating: 5, tagline: '2026/6/9 GA，Fable 5 = Mythos 级能力普及版；Claude Code 默认已升 Opus 4.8（编程 / Agent 更强）',  url: 'https://claude.ai',                    tags: ['writing','coding','research','data','beginner'], verifiedAt: '2026-06-10' },
    chatgpt:    { name: 'ChatGPT (GPT-5.5 Instant)', org: 'OpenAI',    rating: 5, tagline: '2026/5/5 Instant 升级为默认，幻觉降 52.5% + 调取历史对话 / 文件 / Gmail 个性化记忆',  url: 'https://chat.openai.com',              tags: ['writing','coding','data','research','beginner'] },
    gemini:     { name: 'Gemini 3.5 Flash',  org: 'Google',   rating: 5, tagline: '2026/6/9 强制为全球默认，Enterprise 不可关闭；3.5 Pro（2M 上下文 + Deep Think）跳票至 7 月，仍限 Vertex 企业预览',    url: 'https://gemini.google.com',            tags: ['writing','data','research','design'], verifiedAt: '2026-06-25' },
    perplexity: { name: 'Perplexity Pro',    org: 'Perplexity',rating: 5, tagline: '带引用的研究式搜索，替代传统搜索引擎',              url: 'https://perplexity.ai',                tags: ['research','writing','trends','beginner'] },
    notebooklm: { name: 'NotebookLM',        org: 'Google',    rating: 5, tagline: '文档转 AI 播客讨论，消化长材料的神器',              url: 'https://notebooklm.google.com',        tags: ['research','writing','trends','beginner'] },
    manus:      { name: 'Manus · My Computer', org: 'Manus',  rating: 4, tagline: '桌面版可读写本机文件 + 控制应用；Meta $2B 收购被中方阻止，6/11 与 Meta 运营拆分完成，6/18 创始团队拟按 $20 亿原价回购；ARR 已达 $4.5 亿',  url: 'https://manus.im',                     tags: ['agent','research','coding','data'], verifiedAt: '2026-06-25' },

    // ── 国内大模型 & 助手 ──────────────────────────
    doubao:     { name: '豆包 2.1',          org: '字节跳动',  rating: 5, tagline: '2026/6/23 火山引擎大会升 2.1 Pro（跨过生产门槛），国内最顺滑的多模态助手 + 实时语音通话',              url: 'https://www.doubao.com',               tags: ['writing','research','beginner','cn'], verifiedAt: '2026-06-25' },
    deepseek:   { name: 'DeepSeek V4',       org: 'DeepSeek',  rating: 5, tagline: '2026/4/24 开源 MoE（Pro 1.6T / Flash 284B），1M 上下文，5/22 定价永久化 $0.435/M 入 · $0.87/M 出',  url: 'https://chat.deepseek.com',            tags: ['coding','research','dev','cn'] },
    kimi:       { name: 'Kimi K2.6',         org: 'Moonshot',  rating: 5, tagline: '2026/4/20 GA，1T MoE / 32B 激活 + 262K 上下文 + 300 Agent 群；6/12 加出 K2.7-Code 编程专用（思考 token -30% / 编程 +21.8%）',  url: 'https://kimi.moonshot.cn',             tags: ['research','writing','data','cn','beginner'], verifiedAt: '2026-06-25' },
    qwen:       { name: 'Qwen 3.7-Plus',     org: '阿里',       rating: 5, tagline: '2026/6/1 GA，多模态（视觉+视频）+ 1M 上下文 + 深度推理 + 自主迭代，约 Qwen 3.7 Max 1/6 价格',  url: 'https://tongyi.aliyun.com',            tags: ['writing','coding','cn'], verifiedAt: '2026-06-10' },
    zhipu:      { name: 'GLM-5.2',           org: 'Z.ai (智谱)', rating: 5, tagline: '2026/6/13 旗舰，744B MoE / 40B 激活 + 1M 上下文（5.1 的 5 倍）+ 8 小时自主编程，MIT 开源；智能指数 51 超 DeepSeek V4 Pro / Kimi K2.6',     url: 'https://chatglm.cn',                   tags: ['writing','coding','cn'], verifiedAt: '2026-06-25' },

    // ── 编程 / 开发 ───────────────────────────────
    cursor:     { name: 'Cursor',            org: 'Anysphere', rating: 5, tagline: '2026/6/22 升 3.9：Customize 面板统管 plugins / skills / MCP / subagents；6/17 云端 Agent <10 分钟搭环境 + Auto-review 安全分级', url: 'https://cursor.com',                   tags: ['coding','dev','beginner'], verifiedAt: '2026-06-25' },
    claudecode: { name: 'Claude Code',       org: 'Anthropic', rating: 5, tagline: '2026/6 默认升 Opus 4.8（Max/Team/Enterprise）+ v2.1.169 安全模式 / /cd 命令；占公开 GitHub 提交 4%', url: 'https://www.anthropic.com/claude-code',tags: ['coding','dev','agent'], verifiedAt: '2026-06-10' },
    codex:      { name: 'OpenAI Codex (CLI)', org: 'OpenAI',   rating: 5, tagline: '可在 Claude Code 内当 reviewer；6 月 Goal mode 全平台 GA + macOS Record & Replay 把一次操作录成可复用 skill', url: 'https://github.com/openai/codex',      tags: ['coding','dev','agent'], verifiedAt: '2026-06-25' },
    windsurf:   { name: 'Windsurf',          org: 'Cognition', rating: 4, tagline: 'Devin 团队出品，Cascade 代理模式体验顺滑',           url: 'https://windsurf.com',                 tags: ['coding','dev','agent'] },
    copilot:    { name: 'GitHub Copilot',    org: 'GitHub',    rating: 4, tagline: '编辑器内的 AI 代码补全 + PR Review Agent',            url: 'https://github.com/features/copilot',  tags: ['coding','dev','beginner'] },
    v0:         { name: 'v0.app',            org: 'Vercel',    rating: 5, tagline: '2026/1 由 v0.dev 升级 v0.app，一句话产 React + Next.js 全栈',  url: 'https://v0.app',                       tags: ['coding','design','beginner'] },
    bolt:       { name: 'Bolt.new',          org: 'StackBlitz',rating: 5, tagline: '浏览器里一句话跑出完整 Web 应用，WebContainer 零配置',             url: 'https://bolt.new',                     tags: ['coding','design','beginner'] },
    lovable:    { name: 'Lovable',           org: 'Lovable',   rating: 5, tagline: '2 个月 ARR 破 2000 万美元，欧洲史上最快增长的非技术用户 SaaS 构建器',            url: 'https://lovable.dev',                  tags: ['coding','design','beginner'] },
    replit:     { name: 'Replit Agent',      org: 'Replit',    rating: 4, tagline: '从想法到部署的一体化 Agent，手机也能写代码',          url: 'https://replit.com',                   tags: ['coding','dev','beginner'] },

    // ── 图像 ──────────────────────────────────────
    midjourney: { name: 'Midjourney v8.1',   org: 'Midjourney',rating: 5, tagline: '2026/4/30 v8.1 Alpha，--hd 默认 2K，5× 出图，文本渲染 + image weights 回归', url: 'https://midjourney.com',               tags: ['design'] },
    nanobanana: { name: 'Nano Banana Pro',   org: 'Google',    rating: 5, tagline: 'Gemini 3 Pro Image，4K 输出 + 14 张参考图 + 5 人物一致性 + 多语言文字',  url: 'https://gemini.google.com',            tags: ['design','beginner'] },
    seedream:   { name: 'Seedream 5.0',      org: '字节跳动',  rating: 5, tagline: '视觉推理 + 实时联网检索，中文出图首选',                url: 'https://jimeng.jianying.com',          tags: ['design','beginner','cn'] },
    flux:       { name: 'Flux 2 (Klein)',    org: 'Black Forest',rating: 4, tagline: '2025/11 起 Pro/Flex/Dev/Klein 四档，2026/1 Klein 开源，最高 4MP + Apache 2.0',     url: 'https://blackforestlabs.ai',           tags: ['design','dev'] },
    ideogram:   { name: 'Ideogram 4.0',      org: 'Ideogram',  rating: 4, tagline: '2026/6/3 开源 9.3B，2K 原生 + JSON 布局控制 + 文本渲染行业最强 (0.97/X-Omni)，Apache 2.0', url: 'https://ideogram.ai',                  tags: ['design'], verifiedAt: '2026-06-10' },
    recraft:    { name: 'Recraft v3',        org: 'Recraft',   rating: 4, tagline: '矢量图 / 品牌 VI / 图标批量生成',                     url: 'https://recraft.ai',                   tags: ['design'] },
    firefly:    { name: 'Adobe Firefly',     org: 'Adobe',     rating: 4, tagline: '商用安全授权，深度集成 Photoshop / Illustrator',      url: 'https://firefly.adobe.com',            tags: ['design'] },

    // ── 视频 ──────────────────────────────────────
    seedance:   { name: 'Seedance 2.5',      org: '字节跳动',  rating: 5, tagline: '2026/6/23 火山引擎大会发布 2.5：30 秒一镜到底 + 4K + 50 张参考图，企业 beta 中、7 月初公开；2.0 已升 4K', url: 'https://www.volcengine.com/product/seedance', tags: ['video','cn'], verifiedAt: '2026-06-25' },
    veo3:       { name: 'Google Flow (Veo 3.1)', org: 'Google', rating: 5, tagline: '2026/5 并入 Flow；6/1 Veo 3.1 更丰富音频 + 叙事控制 + 增强现实感；Gemini Omni Flash 向 AI Plus/Pro/Ultra 开放',  url: 'https://deepmind.google/technologies/veo', tags: ['video'], verifiedAt: '2026-06-10' },
    kling:      { name: '可灵 3.0',          org: '快手',      rating: 5, tagline: '2026/2/5 发布 4 模型矩阵；6/17 加出 3.0 Turbo（更快更省，vCoT 推理 + 5 语种唇同步）；全球用户破 1 亿 / 224 国',     url: 'https://klingai.com',                  tags: ['video','cn'], verifiedAt: '2026-06-25' },
    hailuo:     { name: 'Hailuo 2.3',        org: 'MiniMax',   rating: 4, tagline: '动作 / 表情 / 物理大升级 + 国漫 / 水墨风更稳；Video Agent 升级为 Media Agent，Fast 版批量再省 50%',         url: 'https://hailuoai.video',               tags: ['video','beginner','cn'], verifiedAt: '2026-06-25' },
    runway:     { name: 'Runway Gen-4.5',    org: 'Runway',    rating: 5, tagline: '2026/5/3 原生音轨 + 参考图条件锁定主体；5/13 推出 Runway Agent 对话式协作剪辑',     url: 'https://runwayml.com',                 tags: ['video'] },
    heygen:     { name: 'HeyGen',            org: 'HeyGen',    rating: 5, tagline: 'AI 数字人口播视频 + 一键多语种翻译',                   url: 'https://heygen.com',                   tags: ['video','writing','beginner'] },

    // ── 音频 ──────────────────────────────────────
    elevenlabs: { name: 'ElevenLabs v3 + Music v2', org: 'ElevenLabs',rating: 5, tagline: '6 月 Music v2 上线（分段 chunk 控制 + 曲风中途切换 + 商用授权）；配 v3 配音 / 70+ 语言克隆 / ElevenMusic iOS 同账号',  url: 'https://elevenlabs.io',                tags: ['audio','beginner'], verifiedAt: '2026-06-25' },
    suno:       { name: 'Suno v5.5',         org: 'Suno',      rating: 5, tagline: '2026/3/27 发布 Voices（自己嗓音）+ Custom Models + My Taste 风格学习',  url: 'https://suno.com',                     tags: ['audio','beginner'] },
    descript:   { name: 'Descript',          org: 'Descript',  rating: 4, tagline: '文字编辑式音视频剪辑 + AI 配音替换',                   url: 'https://descript.com',                 tags: ['audio','video'] },

    // ── 办公 / 写作 / 演示 ────────────────────────
    notion:     { name: 'Notion AI',         org: 'Notion',    rating: 5, tagline: 'Notion 内 AI 写作、总结、翻译 + Q&A',                 url: 'https://notion.so/product/ai',         tags: ['writing','data','beginner'] },
    gamma:      { name: 'Gamma',             org: 'Gamma',     rating: 5, tagline: '一句话生 PPT / 文档 / 网页，设计感在线',               url: 'https://gamma.app',                    tags: ['writing','design','beginner'] },
    grammarly:  { name: 'Grammarly',         org: 'Grammarly', rating: 4, tagline: '英文语法 / 语气 / 清晰度优化',                        url: 'https://grammarly.com',                tags: ['writing','beginner'] },

    // ── 自动化 / Agent ─────────────────────────────
    zapier:     { name: 'Zapier AI Agents',  org: 'Zapier',    rating: 4, tagline: '无代码搭 AI 工作流，6000+ 应用接入',                  url: 'https://zapier.com/ai',                tags: ['data','automation','beginner'] },
    make:       { name: 'Make.com',          org: 'Make',      rating: 3, tagline: '可视化多步自动化，场景复杂时更强',                     url: 'https://make.com',                     tags: ['automation','data'] },
    n8n:        { name: 'n8n',               org: 'n8n',       rating: 4, tagline: '自托管开源工作流，支持 MCP + LLM 节点',                url: 'https://n8n.io',                       tags: ['automation','dev'] },
    dify:       { name: 'Dify',              org: 'Dify',      rating: 4, tagline: '开源 LLM 应用平台，国内团队最爱',                     url: 'https://dify.ai',                      tags: ['automation','dev','cn'] }
}

export const PROJECTS = {
    genai:         { name: 'Generative AI for Beginners',  slug: 'microsoft/generative-ai-for-beginners', stars: '109K', url: 'https://github.com/microsoft/generative-ai-for-beginners',  desc: '21 课生成式 AI 课程，覆盖 LLM / 提示词 / RAG / Agent', topics: ['llm','prompt','rag','agent','beginner'] },
    mlbegin:       { name: 'ML for Beginners',              slug: 'microsoft/ML-For-Beginners',             stars: '85K',  url: 'https://github.com/microsoft/ML-For-Beginners',              desc: '12 周 26 课经典 ML 课程',                             topics: ['ml','data','beginner'] },
    llmcourse:     { name: 'LLM Course',                    slug: 'mlabonne/llm-course',                    stars: '78K',  url: 'https://github.com/mlabonne/llm-course',                     desc: 'LLM 学习路线图 + Colab 笔记本',                        topics: ['llm','path','dev'] },
    promptguide:   { name: 'Prompt Engineering Guide',      slug: 'dair-ai/Prompt-Engineering-Guide',       stars: '73K',  url: 'https://github.com/dair-ai/Prompt-Engineering-Guide',        desc: '提示词工程权威指南',                                    topics: ['prompt','beginner'] },
    cookbook:      { name: 'OpenAI Cookbook',               slug: 'openai/openai-cookbook',                 stars: '72K',  url: 'https://github.com/openai/openai-cookbook',                  desc: 'OpenAI 官方示例和 API 教程',                           topics: ['api','coding','cases'] },
    aibegin:       { name: 'AI for Beginners',              slug: 'microsoft/AI-For-Beginners',             stars: '46K',  url: 'https://github.com/microsoft/AI-For-Beginners',              desc: '12 周 24 课 AI 课程',                                  topics: ['ml','path','beginner'] },
    anthropic:     { name: 'Anthropic Courses',             slug: 'anthropics/courses',                     stars: '20K',  url: 'https://github.com/anthropics/courses',                      desc: 'Anthropic 官方教育课程',                                topics: ['prompt','api'] },
    agents:        { name: 'GenAI Agents',                  slug: 'NirDiamant/GenAI_Agents',                stars: '21K',  url: 'https://github.com/NirDiamant/GenAI_Agents',                 desc: '50+ AI Agent 教程和实现',                              topics: ['agent','cases','dev'] },
    awesomegenai:  { name: 'Awesome Generative AI',         slug: 'steven2358/awesome-generative-ai',       stars: '11.8K',url: 'https://github.com/steven2358/awesome-generative-ai',        desc: '精选生成式 AI 工具和项目列表',                         topics: ['tools','trends'] },
    mlzoom:        { name: 'ML Zoomcamp',                   slug: 'DataTalksClub/machine-learning-zoomcamp',stars: '12.9K',url: 'https://github.com/DataTalksClub/machine-learning-zoomcamp', desc: '4 个月免费 ML 工程课',                                 topics: ['ml','path','data'] },
    llmzoom:       { name: 'LLM Zoomcamp',                  slug: 'DataTalksClub/llm-zoomcamp',             stars: '4.8K', url: 'https://github.com/DataTalksClub/llm-zoomcamp',              desc: '10 周免费 LLM 应用课程',                               topics: ['llm','path','api'] },
    easyvibe:      { name: 'Easy Vibe',                     slug: 'datawhalechina/easy-vibe',               stars: '5.5K', url: 'https://github.com/datawhalechina/easy-vibe',                desc: 'Vibe Coding 2026，AI 辅助编程入门',                   topics: ['coding','beginner'] },
    learnprompt:   { name: 'Learn Prompting',               slug: 'trigaten/Learn_Prompting',               stars: '4.7K', url: 'https://github.com/trigaten/Learn_Prompting',                desc: '提示词学习网站源码',                                    topics: ['prompt','beginner'] },
    roadmap:       { name: 'AI/ML Roadmap',                 slug: 'aadi1011/AI-ML-Roadmap-from-scratch',    stars: '3.3K', url: 'https://github.com/aadi1011/AI-ML-Roadmap-from-scratch',    desc: '完整 AI/ML 学习路线图',                                topics: ['path','ml'] },
    // 2026 新增 ── 实战 / 生态 / 大模型一手仓库
    mcpservers:    { name: 'MCP Servers',                   slug: 'modelcontextprotocol/servers',           stars: '63K',  url: 'https://github.com/modelcontextprotocol/servers',            desc: 'MCP 官方仓库，200+ 服务实现（GitHub / Slack / Notion / Postgres ...）', topics: ['agent','api','tools','beginner'] },
    awesomemcp:    { name: 'Awesome MCP',                   slug: 'punkpeye/awesome-mcp-servers',           stars: '52K',  url: 'https://github.com/punkpeye/awesome-mcp-servers',            desc: '社区精选 MCP server 清单，找现成的"AI 插座"',          topics: ['agent','tools'] },
    deepseekv4:    { name: 'DeepSeek V4',                   slug: 'deepseek-ai/DeepSeek-V4',                stars: '31K',  url: 'https://github.com/deepseek-ai/DeepSeek-V4',                 desc: '2026/4/24 开源 1.6T MoE，MIT 许可，可商用 + 本地部署',  topics: ['llm','dev','cn'] },
    glm5:          { name: 'GLM-5',                          slug: 'zai-org/GLM-5',                         stars: '15K',  url: 'https://github.com/zai-org/GLM-5',                            desc: '智谱 GLM-5.2 开源旗舰（6/13），744B MoE + 1M 上下文 / MIT 许可',           topics: ['llm','dev','cn'] },
    kimik2:        { name: 'Kimi K2',                       slug: 'MoonshotAI/Kimi-K2',                     stars: '14K',  url: 'https://github.com/MoonshotAI/Kimi-K2',                       desc: 'Moonshot 开源 K2.6 / K2.7-Code（6/12），1T MoE + 262K 上下文 + 300 Agent', topics: ['llm','agent','cn'] },
    flux2repo:     { name: 'FLUX.2',                         slug: 'black-forest-labs/flux2',               stars: '24K',  url: 'https://github.com/black-forest-labs/flux2',                  desc: 'FLUX.2 官方推理仓，Klein Apache 2.0，4MP 图像',         topics: ['design','dev'] },
    qwencode:      { name: 'Qwen Code',                     slug: 'QwenLM/Qwen3-Coder',                     stars: '11K',  url: 'https://github.com/QwenLM/Qwen3-Coder',                       desc: '通义 Qwen3 Coder + 命令行 Agent，OpenAI / Anthropic API 兼容', topics: ['coding','agent','cn'] },
    claudeCookbk:  { name: 'Claude Cookbook',               slug: 'anthropics/claude-cookbooks',            stars: '14K',  url: 'https://github.com/anthropics/claude-cookbooks',              desc: 'Anthropic 官方手册：tool use / RAG / Agent / 视觉应用', topics: ['api','agent','prompt'] },
    handsonllm:    { name: 'Hands-On LLM',                  slug: 'iusztinpaul/hands-on-llms',              stars: '6.7K', url: 'https://github.com/iusztinpaul/hands-on-llms',                desc: 'LLMOps 完整工程：训练 / 微调 / 部署 / RAG 一条龙',     topics: ['llm','path','api','dev'] },
    aiagents:      { name: 'AI Agents for Beginners',       slug: 'microsoft/ai-agents-for-beginners',      stars: '46K',  url: 'https://github.com/microsoft/ai-agents-for-beginners',        desc: '微软 11 课 Agent 入门，含 AutoGen + Semantic Kernel 实战', topics: ['agent','beginner','path'] },
    rags:          { name: 'RAG Techniques',                slug: 'NirDiamant/RAG_Techniques',              stars: '17K',  url: 'https://github.com/NirDiamant/RAG_Techniques',                desc: '20+ 种 RAG 实现 (Naive / Advanced / Modular / GraphRAG)',  topics: ['rag','dev','cases'] },
    promptbig:     { name: 'Big Prompt Library',            slug: 'AmadAlam/Big-prompt-Library',            stars: '4.8K', url: 'https://github.com/AmadAlam/Big-prompt-Library',              desc: '按场景分类的 200+ prompt，覆盖编程 / 写作 / 设计',     topics: ['prompt','tools','cases'] }
}

export const SKILL_BRANCHES = {
    prompt: {
        icon: '💬', name: '提示词工程', subtitle: '所有 AI 使用的基础技能',
        items: ['清晰指令编写', '角色与人设设定', '输出格式指定（JSON / 表格）', 'Few-shot 示例式提示', 'Chain-of-thought 思维链', 'System Prompt 设计']
    },
    coding: {
        icon: '💻', name: 'AI 编程辅助', subtitle: '从代码补全到 Agent 自主开发',
        items: ['用 AI 解释 / 调试 / 重构代码', 'Cursor Composer + Background Agents', 'Claude Code 终端 Agent + CLAUDE.md 项目规则', 'v0 / Bolt / Lovable 快速做产品', 'MCP 接入数据库 / GitHub / 内部系统', 'Anthropic / OpenAI API + Agent SDK 开发']
    },
    design: {
        icon: '🎨', name: 'AI 绘图', subtitle: '2026 年图像 = 风格一致性 + 多工具协同',
        items: ['图像提示词（风格 / 主体 / 光线 / 镜头）', 'Midjourney v8 风格 ref + character ref', 'Nano Banana Pro 角色一致性编辑', 'Seedream 5.0 中文 prompt + 视觉推理出图', 'Flux 2 + ComfyUI + LoRA 本地工作流', 'Recraft 矢量图 / 品牌 VI 批产']
    },
    video: {
        icon: '🎬', name: 'AI 视频创作', subtitle: '2026 是视频年：成本降 10 倍、单价涨 2 倍',
        items: ['视频 prompt（运镜 / 物理 / 时长 / 音轨）', 'Seedance 2.5 / 可灵 3.0 Turbo / Runway Gen-4.5 出片', 'Google Flow (Veo 3.1) 原生多模态短片 + 更丰富音频 / 叙事控制', 'HeyGen 数字人 / Runway Agent 对话式剪辑', 'Suno v5.5 + ElevenLabs Music v2 配乐 + 配音', 'Pipeline：脚本 → 分镜 → 成片 → 剪辑']
    },
    writing: {
        icon: '✍️', name: 'AI 写作与内容', subtitle: '核心写作 / 营销 / 长篇',
        items: ['语气与风格控制', '摘要与提炼', '广告 / 邮件营销文案', 'SEO 内容优化', '电子书 / 研究论文辅助', '内容跨平台复用']
    },
    automation: {
        icon: '⚙️', name: 'AI 自动化与工作流', subtitle: 'AI Agent + 流程自动化',
        items: ['Zapier AI 工作流', 'Make.com 多步自动化', 'Custom GPTs / Claude Projects', 'AI 表格分析', '文档提取与解析', '邮件自动分类']
    },
    audio: {
        icon: '🎙️', name: 'AI 音频与语音', subtitle: 'TTS / 音乐 / 播客',
        items: ['ElevenLabs 语音克隆', 'Suno / Udio 音乐生成', 'Whisper 语音转文字', 'Descript 播客编辑', 'NotebookLM 播客摘要', '音效生成']
    },
    product: {
        icon: '🚀', name: '构建 AI 产品', subtitle: '从想法到发布',
        items: ['Build vs Buy vs Wrap 评估', '模型选型与成本估算', '提示词版本管理', 'RAG 知识库构建', 'AI Agent 开发', '监控 AI 质量和成本']
    }
}

const PERSONAS = {
    dev:      { tag: '开发者',        title: '开发者的 AI 副驾路线', blurb: '以「AI 为编程副驾」切入，优先把日常开发流程改造成 AI 辅助流水线。掌握提示词基础后，让代理式工具承担重复任务，把时间花在架构和审查上。' },
    creative: { tag: '创意工作者',    title: '创意工作者的 AI 路线', blurb: '从生成式创作工具切入，建立「人类创意 × AI 迭代」的新工作流。核心是快速原型 + 风格可控 + 跨媒介输出。' },
    business: { tag: '商务 / 职场',   title: '职场人的 AI 效率路线', blurb: '用 AI 压缩信息处理与文档协作成本，把节省的时间花在判断与沟通上。先从日常输入输出高频场景下手，收益最大。' },
    student:  { tag: '学生',          title: '学生的 AI 学习路线',   blurb: '把 AI 当成永不疲倦的学习伙伴。重点是建立批判性使用习惯，而不是抄答案 —— 学会「让 AI 教你怎么学」。' }
}

const LEVEL_META = {
    daily:     { tag: '高频用户', hint: '你已经有稳定的 AI 使用习惯，这份路线会帮你往深度 / 自动化方向进阶。' },
    sometimes: { tag: '偶尔使用', hint: '你已经尝过甜头，下一步是把 AI 变成稳定工作流的一部分。' },
    rarely:    { tag: '浅度接触', hint: '你刚踏进门，下面推荐的工具都以「能快速上手」为优先。' },
    never:     { tag: '全新入门', hint: '零基础也没问题，先装好这些工具、跑通一轮，再决定要往哪个方向深入。' }
}

const LEARNING_TIPS = {
    video:     { emoji: '📺', title: '视频式学习', body: '以 B 站 / YouTube 的项目实战类频道为主线，1.25× 倍速 + 边看边记 Notion 笔记。每个视频结束后复述一遍，没复述出来的就回看那段。' },
    docs:      { emoji: '📄', title: '文档式学习', body: '优先官方文档 + 一手技术博客，建立最可靠的信息源。把每个工具的「最小可用子集」先读透，再回头看高级特性。' },
    hands:     { emoji: '🛠️', title: '动手实战学习', body: '每学一个概念就立刻做一个 30 分钟内能完成的小 demo。不求完美，求「能跑 + 能改」。开源项目选一个自己看得懂的 fork 下来改。' },
    community: { emoji: '💬', title: '社群式学习', body: '加入 1-2 个活跃的 Discord / 微信群，每周至少分享 1 次自己的实践。在回答别人问题时，自己学得最快。' }
}

const USAGE_TO_SKILL = {
    writing: 'writing',
    coding:  'coding',
    design:  'design',
    data:    'automation'
}

const IDENTITY_AGENT_POOL = {
    dev:      ['claude','claudecode','cursor','codex','windsurf','copilot','deepseek','v0','bolt','chatgpt','perplexity','manus'],
    creative: ['midjourney','seedream','nanobanana','ideogram','seedance','veo3','kling','runway','heygen','suno','elevenlabs','gamma','chatgpt'],
    business: ['doubao','chatgpt','claude','kimi','notion','gamma','perplexity','notebooklm','zapier','heygen','manus'],
    student:  ['claude','chatgpt','doubao','perplexity','kimi','notebooklm','notion','gamma','grammarly']
}

const USAGE_AGENT_POOL = {
    writing: ['claude','chatgpt','doubao','kimi','notion','gamma','perplexity','notebooklm','grammarly'],
    coding:  ['claudecode','cursor','codex','windsurf','copilot','deepseek','v0','bolt','lovable','replit','claude'],
    design:  ['midjourney','nanobanana','seedream','ideogram','recraft','flux','firefly','seedance','veo3','kling','runway','heygen','gamma','v0'],
    data:    ['claude','chatgpt','gemini','kimi','notion','zapier','make','n8n','dify','perplexity','manus']
}

function pickAgents(answers) {
    const fromIdentity = IDENTITY_AGENT_POOL[answers.identity] || []
    const fromUsage    = USAGE_AGENT_POOL[answers.usage]       || []

    // Beginner-positioned report: always prefer beginner-friendly agents.
    const score = {}
    for (const k of fromIdentity) score[k] = (score[k] || 0) + 1
    for (const k of fromUsage)    score[k] = (score[k] || 0) + 2
    for (const k of Object.keys(score)) {
        if (AGENTS[k].tags.includes('beginner')) score[k] += 1
    }

    return Object.keys(score)
        .filter(k => AGENTS[k])
        .sort((a, b) => (score[b] - score[a]) || (AGENTS[b].rating - AGENTS[a].rating))
        .slice(0, 8)
        .map(k => AGENTS[k])
}

const REAL_TASK_TOPIC = {
    improve: ['tools', 'beginner', 'prompt'],
    build:   ['cases', 'coding', 'agent'],
    create:  ['prompt', 'cases'],
    learn:   ['path', 'llm', 'ml', 'beginner']
}

function pickProjects(answers) {
    const wanted = new Set(REAL_TASK_TOPIC[answers.realTask] || ['beginner'])
    // Match usage → topic
    const usageTopic = { writing:'prompt', coding:'coding', design:'prompt', data:'ml' }[answers.usage]
    if (usageTopic) wanted.add(usageTopic)
    // Match identity → topic
    const idTopic = { dev:'coding', creative:'prompt', business:'tools', student:'beginner' }[answers.identity]
    if (idTopic) wanted.add(idTopic)

    const scored = Object.values(PROJECTS).map(p => {
        let s = 0
        for (const t of p.topics) if (wanted.has(t)) s += 1
        // Beginner baseline: boost entry-level projects.
        if (p.topics.includes('beginner')) s += 1
        return { p, s }
    })
    return scored
        .sort((a, b) => b.s - a.s || parseFloat(b.p.stars) - parseFloat(a.p.stars))
        .slice(0, 6)
        .map(x => x.p)
}

function pickSkills(answers) {
    const primaryKey = USAGE_TO_SKILL[answers.usage] || 'prompt'
    // Secondary is always prompt engineering unless primary already is prompt.
    const secondaryKey = primaryKey === 'prompt'
        ? (answers.identity === 'dev' ? 'coding' : 'writing')
        : 'prompt'
    return [SKILL_BRANCHES[primaryKey], SKILL_BRANCHES[secondaryKey]]
}

function buildSteps(answers) {
    const base = {
        improve: [
            '挑 1 件本周必须交付的工作（邮件 / 周报 / 文档），让 AI 先跑一版初稿',
            '记录三个数字：原来要多久、AI 辅助后多久、终稿里 AI 贡献占比',
            '把跑对的那条 prompt 存成「模板 001」，下次同类任务直接复用'
        ],
        build: [
            '用 v0 / Bolt / Lovable 选一个真实需求，限定 1 周内做出可访问 URL',
            '每次让 AI 改代码都写一句 commit message，留下迭代轨迹',
            '找 3 个真实用户试用，收集 3 条反馈，再决定下一版迭代方向'
        ],
        create: [
            '锁定 1 个主题 + 1 套 prompt 模板，一周内产出 10 件同系列作品',
            '挑 3 件最好的发到你常用的平台（小红书 / 即刻 / 视频号）',
            '按「最高赞 / 最低赞」各 1 件复盘，沉淀一份个人风格档案'
        ],
        learn: [
            '让 AI 列出目标领域的 10 个关键词，按顺序逐一给你讲清楚',
            '每学一个概念让 AI 出 3 道题考你，答错的再深挖一轮',
            '产出一页 A4「我理解的这个领域」，AI 只做校对不做代笔'
        ]
    }
    return base[answers.realTask] || base.improve
}

// ── First-hour fast win ────────────────────────────────────────────────────
// Mini playbook: "what to do in the very first hour to get a feel for AI".
// Designed to be concrete enough to follow blindly.
const FAST_WINS = {
    writing: {
        title: '把下周要交的一份文档用 Claude 写 70% 初稿',
        steps: [
            '打开 Claude（claude.ai），新建对话，默认 Sonnet 4.6（已超过上代 Opus 编程评分，写文章也最稳）',
            '粘贴文档的标题 + 要点大纲（没有就口述），上传相关资料当作上下文（最多 1M tokens，900 页 PDF 也吞得下）',
            '让它生成初稿，明确"面向谁、字数、语气、避免什么"',
            '不满意就具体指出问题（"第 2 段太空"），让它只改那一段',
            '定稿后问："以后我写类似的东西，最好用什么样的 prompt？" 存成你的第一条模板'
        ],
        expect: '30-45 分钟。大多数人会在这里第一次感受到"啊这就是生产力"。'
    },
    coding: {
        title: '用 Claude Code / Cursor 把一个真实的 bug 从诊断修复到提交',
        steps: [
            '安装 Claude Code（终端 `npm i -g @anthropic-ai/claude-code`，2026/6 默认升 Opus 4.8 + /cd 命令）或下载 Cursor（Design Mode 点选 UI 改 + 多 Agent 并行）',
            '进入一个你熟悉的代码仓库，打开一个真实存在的 bug 或小 feature',
            '用自然语言描述现象 + 期望行为，让 AI 先解释问题、再改代码（高难度任务可用 /codex:adversarial-review 让 Codex 当反方）',
            '逐处审查 diff，不懂就追问"这段为什么这么写"，不要一路 Accept',
            '修完了让它帮你写 commit message，并记下"它做对了什么 / 做错了什么"'
        ],
        expect: '45-60 分钟。关键是"人审 AI 改"，而不是"AI 审 AI 改"。'
    },
    design: {
        title: '用 Seedream / Midjourney 产出 12 张统一风格的配图',
        steps: [
            '国内选即梦（Seedream 5.0）免费额度够用；海外用 Midjourney v8.1（2026/4/30 出，--hd 默认 2K，5× 速度）',
            '锁定 3 个关键词：风格 / 主体 / 光线（例："赛博朋克 · 猫咪 · 霓虹逆光"）',
            '用同一套 prompt 模板生成 12 张，只换主体关键词',
            '挑 2 张最好的，用 Nano Banana Pro（Gemini 3 Pro Image）做细节编辑 / 换背景；它支持一次给 14 张参考图保持一致性',
            '存一份"风格种子库"到 Notion：prompt + 参考图 + 最佳 seed'
        ],
        expect: '60 分钟。结束你会得到一套能反复调用的视觉风格套件。'
    },
    data: {
        title: '把一份真实 Excel / CSV 交给 AI 做一次完整分析',
        steps: [
            '打开 Claude（或 Kimi / ChatGPT），上传一份手头的 CSV / Excel',
            '先让它做"数据体检"：列含义、缺失、异常、分布特征',
            '基于体检提 3 个你最想知道的业务问题，逐个追问',
            '让它把结论做成 1 页 Markdown 报告 + 对应可跑的 Python 代码',
            '收尾问："以后碰到类似数据，提什么问题能最快洞察？" 存下这套提问法'
        ],
        expect: '45 分钟。你会发现 AI 最强的不是算，而是帮你提出对的问题。'
    }
}

// ── 4-week onboarding program (identity × level) ────────────────────────────
// The most frequently-asked question from beginners is "每周做什么才能真
// 正开始用起来？". This matrix answers it without pretending to be magic.
const FOUR_WEEK_PLAN = {
    dev: [
        { week: 1, focus: '建立 AI 编辑器肌肉记忆', tasks: [
            '每天至少 30 分钟在 Cursor / Claude Code 里写代码',
            '每日沉淀 1 条 prompt 模板（bugfix / 重构 / 写测试各一）',
            '关掉 AI 自己写 30 分钟，对比"有 AI / 无 AI"产出差距'
        ]},
        { week: 2, focus: '把代理式工具用到真项目', tasks: [
            '选一个真实的小任务（<4h），让 Cursor Composer 或 Claude Code 全程参与',
            '学会区分"让 AI 写" vs "让 AI 改" vs "让 AI 审"',
            '为项目写一份 CLAUDE.md / .cursorrules，约束它的风格'
        ]},
        { week: 3, focus: '接 API + MCP 做个小工具', tasks: [
            '用 Anthropic / OpenAI API 写一个 50 行以内的个人脚本',
            '试着挂一个 MCP Server（文件系统 / GitHub / 数据库），让 Claude Code 直接调',
            '把这个工具接入你每天都碰的工作流（命令行 / 浏览器扩展 / Slack / 飞书）'
        ]},
        { week: 4, focus: '输出 + 迭代', tasks: [
            '整理本月"哪些 AI 做得比我好 / 差"的笔记',
            '开源或分享一个小工具 / 模板，收真实反馈',
            '定下月目标：1 项技能 + 1 个工具 + 1 个可展示产出'
        ]}
    ],
    creative: [
        { week: 1, focus: '建立视觉提示词直觉', tasks: [
            '每天 20 个图像 prompt 实验，只调一个维度（光线 / 镜头 / 风格）',
            '每次"翻车"截图 + 记 prompt，观察规律',
            '用 Nano Banana / Seedream 建 5 套"风格 + 角色"一致性档案'
        ]},
        { week: 2, focus: '加入视频 / 音频维度', tasks: [
            '用 Seedance 2.0 / 可灵 3.0 / Google Flow (Veo 3.1) / Runway Gen-4.5 把静图延伸为 5-15 秒短片（注意：Seedance 2 在中国大陆 / 美国之外都可用）',
            '用 Suno v5.5 生成 30 秒配乐（试试 Voices 把自己嗓音录进去）',
            '用 HeyGen 做一段 15 秒数字人开场 / ElevenLabs v3 配情感旁白 / ElevenMusic（4/1 上线 iOS）做商用授权 BGM'
        ]},
        { week: 3, focus: '工业化流水线', tasks: [
            '画一张"选题 → 脚本 → 分镜 → 成片"流水线图，每一步指定工具',
            '把 4 个环节跑通一整条，产出一个完整的 30 秒短片',
            '分别记录时长 / 成本 / 返工率，找出最大瓶颈'
        ]},
        { week: 4, focus: '品牌与发布', tasks: [
            '选 1 个社媒阵地（小红书 / 抖音 / 视频号）开"每日 1 作品"21 天挑战',
            '建立版权 / 授权 / AI 标识合规清单（尤其商用前）',
            '回看第 1 周作品，对比进步轨迹，做一张"风格进化图"'
        ]}
    ],
    business: [
        { week: 1, focus: '高频文档场景 AI 化', tasks: [
            '邮件 / 周报 / 会议纪要全部先过一遍豆包或 Claude',
            '每日沉淀 1 条提示词模板（对外 / 对内 / 汇总各一）',
            '每天记"AI 省下了多少分钟"，周末汇总一次'
        ]},
        { week: 2, focus: '信息处理', tasks: [
            '把每天读的长文 / PDF / 录音扔给 NotebookLM 或 Kimi 做摘要',
            '每周用 Gamma 产出 1 份"本周信息洞察"，可分享的网页版',
            '开始用 Perplexity 替代搜索引擎做行业调研'
        ]},
        { week: 3, focus: '工作流自动化', tasks: [
            '用 Zapier / 扣子 / n8n 搭 1 条日常重复任务的 AI 链路',
            '加入 AI 节点（摘要 / 分类 / 生成回复），让它先"跑 7 天"',
            '把 Manus 或 Claude Desktop + MCP 用于一件你常做的操作'
        ]},
        { week: 4, focus: '向团队推广', tasks: [
            '给 1-2 位同事做一次 30 分钟分享 + 现场演示',
            '把最好用的 5 条 prompt 模板沉淀到共享空间 / 飞书知识库',
            '定下月目标：挑一个跨部门场景做 AI 改造 PoC'
        ]}
    ],
    student: [
        { week: 1, focus: '把 AI 变成学习助教', tasks: [
            '每天用 Claude / 豆包拆解 1 个学科概念（让它反问你来检查理解）',
            '建一个"我问过的好问题"清单（越具体越好）',
            '每天 15 分钟用 Anki + AI 生成抽认卡片'
        ]},
        { week: 2, focus: '做中学', tasks: [
            '选一个感兴趣的课题，用 AI 陪你做 3 天小研究',
            '用 NotebookLM / Kimi 消化 3-5 篇论文，生成对比表',
            '产出一份你自己写的 1 页摘要，AI 只当校对'
        ]},
        { week: 3, focus: '动手做一个小作品', tasks: [
            '用 v0 / Bolt / Lovable 做一个与学科相关的交互 demo',
            '发给导师 / 同学收集 3 条反馈',
            '写一篇"做这个 demo 学到了什么"的复盘（可发小红书 / 即刻）'
        ]},
        { week: 4, focus: '学术伦理 + 持续学习', tasks: [
            '把学校的 AI 使用政策读一遍，定自己的红线（哪些能 AI 哪些不能）',
            '找 2 个你愿意长期关注的 AI 博主 / 频道（中 + 英各一）',
            '给自己定下月主题（深度 > 广度，1 个方向吃透）'
        ]}
    ]
}

// ── Productivity ladder — how far you are from "AI-productive" ─────────────
const PRODUCTIVITY_LADDER = {
    never: [
        { stage: 'L0', name: '好奇', sign: '知道 AI 热但没用过' },
        { stage: 'L1', name: '首次上手', sign: '本周目标：至少 1 次「哇 AI 能做到」' },
        { stage: 'L2', name: '每日使用', sign: '开始把小任务都先问一下 AI' },
        { stage: 'L3', name: '融入工作流', sign: '有固定 3 个以上 AI 场景' },
        { stage: 'L4', name: '交付级',   sign: 'AI 成为你的可交付生产要素' }
    ],
    rarely: [
        { stage: 'L1', name: '尝鲜',     sign: '用过但不经常' },
        { stage: 'L2', name: '日常化',   sign: '本周目标：固定 2 个每日场景' },
        { stage: 'L3', name: '工具链',   sign: '2-3 个 AI 工具互相衔接' },
        { stage: 'L4', name: '产出力',   sign: '别人看到你的输出会问"怎么做到的"' },
        { stage: 'L5', name: '输出',     sign: '开始把自己的最佳实践教给别人' }
    ],
    sometimes: [
        { stage: 'L2', name: '日常化',   sign: '你在这里' },
        { stage: 'L3', name: '工具链',   sign: '本月目标：打通 3 工具工作流' },
        { stage: 'L4', name: '产出力',   sign: '交付物里 AI 是隐形基础设施' },
        { stage: 'L5', name: '输出',     sign: '沉淀文章 / 模板 / 分享' },
        { stage: 'L6', name: '产品化',   sign: '基于 AI 做自己的小产品' }
    ],
    daily: [
        { stage: 'L3', name: '工具链',   sign: '你在这里' },
        { stage: 'L4', name: '产出力',   sign: '量化本月 AI 帮你省下的时间' },
        { stage: 'L5', name: '输出',     sign: '个人品牌 / 最佳实践被他人引用' },
        { stage: 'L6', name: '产品化',   sign: '落地一个 AI-native 小产品' },
        { stage: 'L7', name: '标准化',   sign: '把团队流程固化为可复制 SOP' }
    ]
}

// ── Key concepts: the words you should be able to explain in 1 sentence ───
const KEY_CONCEPTS = [
    { term: 'Prompt',          gloss: '你给 AI 的任务说明 —— 好的 prompt ≈ 好的同事邮件：清晰、分点、带例子。' },
    { term: 'Context window',  gloss: '单次对话能记住的上下文长度；Claude Fable 5 / Opus 4.8 均 1M、DeepSeek V4 / GPT-5.5 1M、Gemini 3.5 Flash / 3.1 Pro 1M、Kimi K2.6 262K、GLM-5.2 1M。' },
    { term: 'Token',           gloss: 'AI 看世界的"字"。中文 1 字 ≈ 1 token，英文 1 词 ≈ 1.3 token；按 token 计价计长度。' },
    { term: 'Hallucination',   gloss: 'AI 自信地编造不存在的事实；数字、论文引用、API 名最容易翻车 — GPT-5.5 Instant 已比 5.3 降 52.5%。' },
    { term: 'RAG',             gloss: '把你自己的资料灌进 AI 再答题 —— 做"能用的企业 AI"最常见路径。' },
    { term: 'Agent',           gloss: '能连续调用工具、自主跑多步任务的 AI（Claude Code / Cursor Build in Parallel / Manus / Kimi 300-Agent 都是）。' },
    { term: 'MCP',             gloss: 'Anthropic 开放的"AI 插座协议"；2025/12 已捐给 Linux Foundation，月装机量破 9700 万。' },
    { term: 'Reasoning model', gloss: '会先"思考"再答的新一代模型（Claude Fable 5 / Opus 4.8 / GPT-5.5 Pro / Gemini 3.1 Pro / DeepSeek V4-Pro）—— 贵但更准。' },
    { term: 'Tool use',        gloss: 'AI 主动决定去调哪个外部工具（搜索 / 代码 / API），是 Agent 的基础能力。' },
    { term: 'Fine-tuning',     gloss: '用专有数据把模型"塑形"到你的场景；2026 多数人用 RAG + prompt + Custom Models 就够。' },
    { term: 'MoE',             gloss: 'Mixture of Experts —— 一次只激活一小部分参数，让 1.6T 大模型跑得像 49B（DeepSeek V4-Pro / Kimi K2.6 / GLM-5.2 都是）。' },
    { term: 'Multimodal',      gloss: '同一个模型处理文字 / 图片 / 语音 / 视频；Google Flow (Veo 3.1) / Seedance 2 / 可灵 3 / Runway Gen-4.5 已能同步出音轨。' },
    { term: 'Open-source',     gloss: '权重公开、可本地部署；2026 代表：DeepSeek V4 (MIT)、GLM-5.2 (MIT)、Qwen 3.6、Kimi K2.6、Flux 2 Klein (Apache 2.0)。' },
    { term: 'Guardrail',       gloss: '给 AI 套的规则与验证，避免输出违规 / 越权 / 虚构 —— 上生产必配。' },
    { term: 'Vibe coding',     gloss: '靠对话不写代码也能造产品的工作方式；v0 / Bolt / Lovable / Replit Agent 都属此列。' },
    { term: 'C2PA',            gloss: '内容可信溯源标准；Seedance 2 / 国内合规要求都已强制；上传素材认它就不易被误伤。' }
]

// ── 2026 Q2 model snapshot ─────────────────────────────────────────────────
// Shown so readers know the report really is current.
// 注：OpenAI Sora 已停服；Veo 已并入 Google Flow，Gemini Omni 替代旧 Veo
// 应用入口。本快照以现役视频模型为准。
// 数据校对日：2026-06-25（每发布新一代旗舰需在 30-90 天内校对）
const MODEL_SNAPSHOT = [
    // 文本 / 推理
    { name: 'Claude Fable 5',         org: 'Anthropic', strength: '2026/6/9 GA，Mythos 级能力普及版，跨 Claude API / AWS Bedrock / Vertex AI / MS Foundry 全平台',     kind: '文本 / 推理' },
    { name: 'Claude Opus 4.8',        org: 'Anthropic', strength: '2026/6 Claude Code 新默认，比 4.7 更强编程 / Agent / 推理，Max / Team Premium / Enterprise 全档高 effort', kind: '文本 / 推理' },
    { name: 'Claude Opus 4.7',        org: 'Anthropic', strength: '2026/4/16 旗舰（已有后继 Opus 4.8），1M 上下文 + 高分辨率图像 (2576px / 3.75MP) + 最强编程 / Agent 底座', kind: '文本 / 推理' },
    { name: 'Claude Sonnet 4.6',      org: 'Anthropic', strength: '2026/2 日常主力，已超过上代 Opus 编程评分，质量 × 速度最优',     kind: '文本 / 推理' },
    { name: 'Claude Haiku 4.5',       org: 'Anthropic', strength: '路由层最便宜档，简单任务自动接管',                                kind: '文本 / 推理' },
    { name: 'GPT-5.5 Instant',       org: 'OpenAI',    strength: '2026/5/5 升级为 ChatGPT 默认，比 5.3 幻觉降 52.5% + 调取历史对话 / 文件 / Gmail 个性化', kind: '文本 / 推理' },
    { name: 'GPT-5.5 Pro',           org: 'OpenAI',    strength: '2026/4/23 发布，可吞乱糟糟多步任务自规划，编程 / 数据 / 文档全能',  kind: '文本 / 推理' },
    { name: 'Gemini 3.5 Flash',      org: 'Google',    strength: '2026/5/19 I/O GA，编程 / Agent 已超 3.1 Pro，速度 × 价格最优',     kind: '文本 / 推理' },
    { name: 'Gemini 3.1 Pro',        org: 'Google',    strength: '1M 上下文 + 64K 输出，可处理 900 页 PDF / 1 小时视频；3.5 Pro（2M 上下文 + Deep Think）已跳票至 7 月（核对 2026-06-25）', kind: '文本 / 推理' },
    { name: 'DeepSeek V4-Pro',       org: 'DeepSeek',  strength: '2026/4/24 开源 1.6T MoE / 49B 激活 + 1M 上下文；5/22 定价永久化 $0.435 入 · $0.87 出 / M tokens', kind: '文本 / 推理' },
    { name: 'DeepSeek V4-Flash',     org: 'DeepSeek',  strength: '同代轻量版，284B / 13B 激活，便宜快，自部署友好',                kind: '文本 / 推理' },
    { name: 'Kimi K2.6 · K2.7-Code', org: 'Moonshot',  strength: '2026/4/20 K2.6 GA，1T MoE / 32B 激活 + 262K 上下文；6/12 K2.7-Code 编程专用（思考 token -30% / Kimi Code Bench v2 +21.8%）（核对 2026-06-25）', kind: '文本 / 推理' },
    { name: 'GLM-5.2',               org: 'Z.ai (智谱)', strength: '2026/6/13 旗舰，744B MoE + 1M 上下文（5.1 的 5 倍）+ 8 小时自主，智能指数 51 超 DeepSeek V4 Pro / Kimi K2.6，MIT 开源（核对 2026-06-25）',   kind: '文本 / 推理' },
    { name: 'Qwen 3.7-Plus',          org: '阿里',      strength: '2026/6/1 GA，多模态（视觉+视频）+ 1M 上下文 + 深度推理 / 工具调用 / 自主迭代，约 Qwen 3.7 Max 1/6 价格', kind: '文本 / 推理' },
    { name: '豆包 2.1',              org: '字节跳动',  strength: '2026/6/23 火山引擎大会升 2.1 Pro（跨过生产门槛），国内体验最顺滑，原生语音通话 + 拍照对话（核对 2026-06-25）',                          kind: '文本 / 推理' },
    // 图像
    { name: 'Midjourney v8.1',       org: 'Midjourney',strength: '2026/4/30 v8.1，--hd 默认 2K，5× 出图速度；David Holz 5/6 预告 V8.2 + 全新编辑模型', kind: '图像' },
    { name: 'Nano Banana Pro',       org: 'Google',    strength: 'Gemini 3 Pro Image，4K 输出 + 14 张多参考图 + 5 人物一致性 + 多语言文本',  kind: '图像' },
    { name: 'Seedream 5.0',          org: '字节跳动',  strength: '视觉推理 + 实时联网检索，中文出图首选',           kind: '图像' },
    { name: 'Flux 2 Pro / Klein',    org: 'Black Forest', strength: '2025/11 起 4 档开源，2026/1 Klein 进 RTX 优化版，最高 4MP + Apache 2.0',   kind: '图像' },
    { name: 'Ideogram 4.0',          org: 'Ideogram',  strength: '2026/6/3 开源 9.3B，2K 原生 + JSON 布局控制 + 文本渲染 0.97 (X-Omni)，Apache 2.0，ComfyUI / Hugging Face 可部署', kind: '图像' },
    // 视频
    { name: 'Google Flow (Veo 3.1)', org: 'Google', strength: '2026/5 并入 Flow；6/1 Veo 3.1 更丰富音频 + 叙事控制 + 增强现实感；Gemini Omni Flash 向 AI Plus/Pro/Ultra 开放', kind: '视频' },
    { name: 'Seedance 2.5',          org: '字节跳动',  strength: '2026/6/23 火山引擎大会发布：30 秒一镜到底 + 4K + 50 张参考图，企业 beta、7 月初公开；2.0 已升 4K（核对 2026-06-25）', kind: '视频' },
    { name: '可灵 3.0 / 3.0 Turbo',  org: '快手',      strength: '2026/2/5 四模型矩阵；6/17 加 3.0 Turbo（更快更省 + vCoT 推理 + 5 语种唇同步）；全球用户破 1 亿（核对 2026-06-25）',           kind: '视频' },
    { name: 'Runway Gen-4.5',        org: 'Runway',    strength: '2026/5/3 原生音轨 + 参考图条件锁定主体；5/13 起 Runway Agent 对话式剪辑',         kind: '视频' },
    { name: 'Hailuo 2.3',            org: 'MiniMax',   strength: '动作 / 表情 / 物理大升级，性价比之选',           kind: '视频' },
    // 音频
    { name: 'Suno v5.5',             org: 'Suno',      strength: '2026/3/27，Voices（自己嗓音）+ Custom Models + My Taste 风格学习',                 kind: '音频' },
    { name: 'ElevenLabs v3 + Music v2', org: 'ElevenLabs',strength: '6 月 Music v2（分段 chunk 控制 + 曲风中途切换 + 商用授权）；70+ 语言克隆 + ElevenMusic iOS（核对 2026-06-25）',                  kind: '音频' }
]

// ── Round 2: deeper / personalised questions ──────────────────────────────
// 注：「每天投入多少」已移到基础 5 题中，round 2 专注于障碍 + 半年目标。
export const EXTENDED_QUESTIONS = [
    { key: 'blocker', q: '目前你最大的障碍是？', choices: [
        { label: '不知从何开始', value: 'start'  },
        { label: '工具挑花眼',   value: 'tools'  },
        { label: '缺实战场景',   value: 'scene'  },
        { label: '学了就忘',     value: 'retain' }
    ]},
    { key: 'horizon', q: '6 个月后你希望达到什么程度？', choices: [
        { label: '日常工作都能 AI 化',   value: 'daily'   },
        { label: '独立做一个 AI 小项目', value: 'project' },
        { label: '能教别人用 AI',        value: 'teach'   },
        { label: '基于 AI 构建产品',     value: 'product' }
    ]}
]

const TIME_PLANS = {
    tight:  { budget: '每天不到 30 分钟 · 3h / 周', plan: ['每天 15 分钟读 1 篇官方指南 + 5 分钟实操', '每周末抽 1 小时复盘 + 整理笔记', '每月尝试 1 个新工具（限定 1 小时内跑通）'] },
    short:  { budget: '每天 30-60 分钟 · 5-7h / 周', plan: ['每天 30 分钟集中练 1 个技能点', '每周跑 1 个 1-2 小时能完工的 demo', '每月上手 1 个新工具，产出对比笔记'] },
    medium: { budget: '每天 1-2 小时 · 8-14h / 周', plan: ['每天 1 小时学习 + 1 小时实战', '每周完成 1 个可以展示的小项目', '每月发布 1 篇实战笔记 / 视频'] },
    long:   { budget: '每天 2 小时+ · 14h+ / 周', plan: ['每天 2 小时主线学习 + 1 小时社群互动', '每周做 2-3 个 mini project', '每月发布 1 个完整作品或提交开源 PR'] }
}

const BLOCKER_REMEDIES = {
    start:  { title: '不知从何开始', tip: '用「1 工具 × 1 任务」原则：今天就挑 ChatGPT 或 Claude，做 1 件手头真实的事（写邮件 / 总结文档），先获得第一个"原来 AI 能做到"的正反馈。' },
    tools:  { title: '工具挑花眼',   tip: '别追新。锁定 3 类任务 × 各 1 个工具（共 3 个），连续用 2 周再考虑替换。"它能做 80%" 就够了，最后 20% 的差异不值得切换成本。' },
    scene:  { title: '缺实战场景',   tip: '从身边拿场景：把一周要交付的工作拆成小任务，挑 3 个用 AI 试着做。即便失败也记录下来 —— 失败本身就是你的专属知识。' },
    retain: { title: '学了就忘',     tip: '建一个「AI 笔记本」：结构固定为 工具 / 场景 / 提示词 / 结果 / 可改进处。每学 1 个技能，立刻产出 1 个可复用的提示词模板。' }
}

const HORIZON_MILESTONES = {
    daily:   { title: '日常工作 AI 化',    steps: ['30 天：日报 / 周报 / 邮件全部 AI 化', '90 天：建立个人提示词库（20+ 条）', '180 天：每周省下 5+ 小时重复性工作'] },
    project: { title: '独立做一个 AI 小项目', steps: ['30 天：用 v0 / Bolt 跑通 1 个 no-code 原型', '90 天：上线 1 个有真实用户的 Web 小应用', '180 天：完成 1 个带 API + 数据持久化的完整项目'] },
    teach:   { title: '能教别人用 AI',      steps: ['30 天：整理一套个人最佳实践笔记', '90 天：给朋友 / 同事做 1 次分享', '180 天：输出 1 系列内容（公众号 / 视频 / 社群直播）'] },
    product: { title: '基于 AI 构建产品',   steps: ['30 天：想清楚要解决的真问题 + 访谈验证', '90 天：MVP 上线 + 10 个真实用户', '180 天：留存 / 付费数据出来，做下一步决策'] }
}

const PROMPT_TEMPLATES = {
    coding: {
        title: '代码重构提示词模板（适合 Claude Opus 4.8 / Fable 5 / GLM-5.2 / DeepSeek V4-Pro）',
        body:
`你是一名资深 {LANGUAGE} 工程师。下面是一段需要重构的代码：

\`\`\`
{CODE}
\`\`\`

请按顺序：
1) 用 3-5 句话说明当前代码的问题（可读性 / 性能 / 安全 / 可测试性）
2) 给出改进方案的思路（先列方案，等我点头再改代码）
3) 输出重构后的代码，保留原有接口，必要处加注释
4) 最后用"改动清单"列出：动了哪里、为什么

约束：不引入新依赖；外部 API 行为兼容；高风险点用 // ⚠ 标出。`
    },
    design: {
        title: '一致风格出图提示词模板（Midjourney v8.1 / Nano Banana Pro / Seedream 5）',
        body:
`Subject: {SUBJECT}
Scene: {SCENE}
Style: {STYLE}, {COLOR_PALETTE}, {LIGHTING}
Composition: {COMPOSITION}, {CAMERA_ANGLE}
Aspect: {ASPECT}
Quality: high detail, sharp focus, cinematic, 2K --hd     // v8.1 原生 2K
Reference: --sref {SREF_URL}                              // 同系列风格锁
Character: --cref {CREF_URL}                              // 同角色锁
Negative: low quality, blurry, watermark, text, extra limbs
Seed: {SEED}   // 保持同一系列风格时复用`
    },
    writing: {
        title: '结构化长文提示词模板',
        body:
`你是 {领域} 领域的资深编辑。请针对「{主题}」写一篇 {字数} 字的 {体裁}，面向 {受众}。

要求：
- 开头一句话说明读完的收获
- 主体 3-5 个有数字或具体例子支撑的要点
- 每个要点配 1 个反面例子 / 常见误区
- 结尾给出"可立即执行"的 1-2 步行动

语气：{tone}。避免套话、"综上所述"、"总之"这类词。
最后请用「自评：1-10 分」并指出 1 条你最想再改的地方。`
    },
    prompt: {
        title: '通用任务提示词模板（角色 + 任务 + 输出 + 步骤 + 自评）',
        body:
`# 角色
你是一名 {role}，有 {domain} 领域 {years} 年经验。

# 任务
{task_description}

# 输入
{input}

# 输出要求
- 格式：{format}（Markdown 列表 / JSON / 表格）
- 长度：{length}
- 必含：{must_include}
- 避免：{must_avoid}

# 工作步骤
1) 先复述一遍你理解的任务（1-2 句）
2) 拆解为 3-5 个子步骤
3) 按步骤输出最终结果
4) 最后用"置信度 1-10"自评 + 列 1 条假设`
    },
    video: {
        title: '视频生成 prompt 模板（Google Flow (Veo 3.1) / 可灵 3 / Seedance 2 / Runway Gen-4.5）',
        body:
`Shot: {SHOT_TYPE}      // wide / medium / close / extreme close
Subject: {SUBJECT}     // 主体描述（外貌 / 服装 / 神态）
Action: {ACTION}       // 动作 / 情绪曲线（起 → 转 → 收）
Camera: {CAMERA_MOVE}  // 推 / 拉 / 摇 / 移 / 跟 / 环绕
Setting: {SETTING}     // 场景 + 时间 + 天气
Style: {STYLE}         // 写实 / 动画 / 胶片 / 国风
Lighting: {LIGHTING}   // 顺光 / 逆光 / 侧光 / 霓虹
Audio: {AUDIO_HINT}    // Google Flow (Veo 3.1) / Seedance 2 / 可灵 3 / Runway Gen-4.5 都支持原生音轨
Duration: {DURATION}   // 5s / 10s / 15s / 30s
Negative: jitter, deformed hands, text artifacts`
    },
    rag: {
        title: 'RAG 知识库问答提示词（企业 / 个人知识库通用）',
        body:
`你只能基于下面的 {NUM} 段引用回答问题：

[1] {CHUNK_1}
[2] {CHUNK_2}
...

问题：{QUESTION}

要求：
1) 每个事实结尾标注来源 [n]
2) 引用之外的内容不要回答；如需推断，写"⟦推断⟧"
3) 答完后另起一段给出"信息缺口"：还需要什么资料才能更准
4) 用 {LANG} 回答，长度 ≤ {WORDS} 字`
    },
    agent: {
        title: 'Agent 多步任务提示词（Claude Code / Manus / Kimi / Cursor Composer）',
        body:
`# 目标
{HIGH_LEVEL_GOAL}

# 边界
- 允许的工具：{TOOLS}（文件读写 / 浏览器 / 终端 / 数据库）
- 禁止：{FORBIDDEN}
- 预算：≤ {STEP_BUDGET} 步 + ≤ {TIME_BUDGET} 分钟

# 工作流
1) 先输出 plan（编号步骤 + 每步预期结果）
2) 等我点头后逐步执行；每步执行前贴当前 plan 进度
3) 任何修改 / 删除 / 网络请求前先复述意图，得到 yes 再做
4) 最后产出：实际结果 + 与 plan 的差异 + 我下一次该如何更省心`
    },
    data: {
        title: '数据分析提示词（Excel / CSV → 业务洞察）',
        body:
`# 角色
你是一名资深数据分析师，擅长用人话讲清数字背后的故事。

# 数据
{ATTACH_CSV_OR_PASTE}

# 任务
1) 先做"数据体检"：每列含义、缺失率、异常值、分布特征（≤ 6 行）
2) 推断 3 个最可能的业务问题（按重要性排序）
3) 用 SQL / pandas 给出每个问题对应的查询代码（直接可跑）
4) 把结论做成 1 页 Markdown 报告 + 1 张能放进 PPT 的图（用 mermaid / chartjson）
5) 给出"再要 2 个补充字段，我就能回答 X 问题"的下一步建议`
    }
}

const PITFALLS = {
    dev:      [
        '直接让 AI 写"黑盒代码" → 先让它解释思路、列出风险，再让它写',
        '一路点 Accept → 把每一处 diff 都当作 Code Review，不懂就追问',
        '只用一个模型 → 不同任务配不同模型（Claude Fable 5 / Opus 4.8 长推理 / Sonnet 4.6 日常 / DeepSeek 省钱 / Cursor Composer 改代码）',
        '忽略 CLAUDE.md / .cursorrules → 把项目约定写进去，AI 才不会到处发明轮子',
        '不用 MCP → 让 Claude / Cursor 直接连你的数据库 / GitHub，胜过反复粘贴'
    ],
    creative: [
        '追求一次到位 → AI 创作就是 10-50 次迭代，把"翻车"也存档当训练',
        '只用中文 prompt 做图 → Midjourney / Flux 关键词转英文更稳；国内场景用 Seedream / 即梦反而中文更顺',
        '忽略商用授权 → 每个工具规则不同，2026 中国《AI 生成内容标识办法》已强制要求标注',
        '一个工具用到死 → Nano Banana 改图、Seedance 出片、Midjourney 起稿，要会编排',
        '只做静图不做视频 → 2026 视频赛道单价是图的 5-10 倍'
    ],
    business: [
        '把敏感数据直接粘到公网 AI → 用企业版 / 私有部署 / 先脱敏',
        '期待 AI 一次到位 → 它是「最强草稿机」，你做最后一公里的判断与定稿',
        '没留追溯 → 重要决策要存"原始 prompt + AI 输出 + 你的修改"，3 个月后才看得懂',
        '只把 AI 当聊天框 → 试试 Manus / Claude Desktop + MCP，让它直接操作你的工具',
        '只自己用 → 把模板沉淀给团队，组织效率才真正提升'
    ],
    student:  [
        '直接抄答案 → 反过来：你解释给 AI 听，让它指出你哪里没想清楚',
        '一次问太大的题 → 拆到"AI 能一次答完"的颗粒度，逐步追问',
        '不交叉验证 → AI 会编造，数字 / 论文 / API 必查原文',
        '只用一个 AI → 同一个问题问 2 个不同家的模型，矛盾点就是你要深挖的地方',
        '完全替代思考 → 学习的核心是构建你自己的心智模型，AI 是脚手架不是楼'
    ]
}

const TEMPLATE_KEY_BY_USAGE = { coding: 'coding', design: 'design', writing: 'writing', data: 'data' }

// ── Outcome hook ──────────────────────────────────────────────────────────
// A compelling, concrete "what's in it for me" opener. Combines the user's
// interest direction + weekly time budget with realistic deliverable counts
// and 2025-2026 市场行情价. Numbers are conservative (bottom-half of the
// range typical freelance / 自媒体 / indie dev data).

const OUTCOME_HOOKS = {
    writing: {
        eyebrow: '方向 · 写作 · 把「会写」变成「能变现」',
        headline: '从苦想每句话，到每周稳定产出 3 篇能发的稿子',
        subline: 'Claude + 豆包 + Gamma 让选题、结构、润色、成稿的时间砍到 1 / 5，你只负责掌舵和判断。',
        deliverables: [
            { icon: '✍️', title: '公众号 / 知乎长文',   base: 6,   unit: '篇 / 月', note: '1,500–3,000 字可发稿' },
            { icon: '📱', title: '小红书 / 即刻',       base: 30,  unit: '条 / 月', note: '日更级，配图文案一体' },
            { icon: '💼', title: '商业文案 / 报告',     base: 4,   unit: '份 / 月', note: '可作为兼职接单稳定产出' },
            { icon: '🎙️', title: 'AI 播客 / 视频口播', base: 2,   unit: '集 / 月', note: 'NotebookLM + HeyGen 一条龙' }
        ],
        income: {
            range: '¥ 2,500 – ¥ 12,000 / 月',
            note: '2026 自媒体冷启动 3-6 个月内可达下限；起量后月入 ¥ 1-5 万属常见成长路径。',
            sources: [
                '自媒体广告 / 分成：¥ 500 – ¥ 3,000 / 篇（依账号体量）',
                '商业文案 / 代写：¥ 800 – ¥ 3,000 / 篇（2026 小红书 / 公众号代写行情）',
                '付费专栏 / 知识星球：¥ 99 – ¥ 299 / 人 · 年，100 人即 ¥ 1-3 万',
                'AI 课程 / Prompt 模板包：抖音 / 小红书 / Gumroad 被动收入'
            ]
        }
    },
    coding: {
        eyebrow: '方向 · 编程 · 把「想法」做成「能上线的产品」',
        headline: '从"我想做个 App"到每月上线 1-2 个真实可访问的网站或工具',
        subline: 'Claude Code + Cursor + v0 + Lovable 的组合拳，让没写过代码的人也能把点子变成线上 URL。',
        deliverables: [
            { icon: '🌐', title: '上线网站 / 小工具',    base: 2, unit: '个 / 月', note: '含域名 + 真实可访问 URL' },
            { icon: '🧩', title: '自动化脚本 / 插件',    base: 4, unit: '个 / 月', note: 'Chrome 插件 / 飞书机器人 / MCP Server' },
            { icon: '📦', title: 'GitHub 作品 / 开源项目', base: 3, unit: '仓 / 月', note: '作为求职 / 独立开发者作品集' },
            { icon: '🤖', title: 'AI Agent / SaaS',     base: 1, unit: '个 / 季度', note: '可付费的独立产品' }
        ],
        income: {
            range: '¥ 5,000 – ¥ 30,000 / 月',
            note: '2026 独立开发者红利期：冷启动 SaaS 首年 MRR ¥ 1,000-8,000；外包单价明显涨。',
            sources: [
                'SaaS 订阅 MRR：¥ 1,000 – ¥ 8,000（冷启动 6 个月均值，2026 行情）',
                '定制开发接单：¥ 3,000 – ¥ 15,000 / 项目（Upwork / Toptal / 程序员客栈）',
                'Chrome 插件 / 独立小工具：Gumroad / 微信小程序 ¥ 99 / 年 × N',
                'AI Agent / 企业 PoC：¥ 10,000 – ¥ 50,000 / 项目（中小企业数字化预算）'
            ]
        }
    },
    design: {
        eyebrow: '方向 · 视觉 · 把 AI 画图与视频变成可交付商单',
        headline: '从"只能做自己看的图"，到每月产出 50+ 张 + 若干短视频的视觉资产',
        subline: 'Midjourney v8 + Seedream 5.0 + Seedance 2.0 + Nano Banana Pro，一个人的产能可匹敌小型团队。',
        deliverables: [
            { icon: '🎨', title: '海报 / 封面 / 头图', base: 40, unit: '张 / 月', note: '小红书 / 视频号 / 公众号级' },
            { icon: '🖼️', title: '插画 / 素材系列',   base: 8,  unit: '套 / 月', note: '可打包成素材包' },
            { icon: '🎬', title: 'AI 短视频 / 广告片', base: 6,  unit: '支 / 月', note: '10-30 秒，Seedance 2.0 / Runway Gen-4.5 / Google Flow (Veo 3.1) 产出' },
            { icon: '🏷️', title: 'Logo / 品牌 VI',   base: 3,  unit: '套 / 月', note: '可作为副业稳定收入源' }
        ],
        income: {
            range: '¥ 3,000 – ¥ 20,000 / 月',
            note: 'AI 视频红利明显：短视频代做单价较 2024 翻倍；静态图接单市场已卷，主要看风格独特性。',
            sources: [
                '小红书 / 闲鱼头像 & 海报：¥ 30 – ¥ 500 / 张',
                'Logo / VI 品牌设计：¥ 500 – ¥ 3,000 / 套',
                'AI 短视频代做：¥ 300 – ¥ 2,000 / 支（2026 主要增量市场）',
                '素材包 / 风格预设：Gumroad / 小报童被动收入 ¥ 1-5K / 月'
            ]
        }
    },
    data: {
        eyebrow: '方向 · 数据 / 自动化 · 把 AI 变成决策与效率杠杆',
        headline: '从"看不懂表格"，到每月交付 5 份让老板拍板的数据洞察 + 3 条自动化',
        subline: 'Claude + Kimi + Zapier / n8n + Manus：取数、解读、成图、自动化一条龙，一周 40 小时工作压到半天。',
        deliverables: [
            { icon: '📊', title: '数据看板 / 周报',    base: 4, unit: '份 / 月', note: '自动刷新 + 中文解读' },
            { icon: '🤖', title: '自动化流程 / Agent', base: 3, unit: '个 / 月', note: 'Zapier / n8n / MCP 组合' },
            { icon: '🧠', title: '行业分析 / 洞察',    base: 2, unit: '份 / 月', note: '可作为付费咨询交付' },
            { icon: '⚙️', title: '企业内部 AI 工具',  base: 1, unit: '个 / 季度', note: '知识库 Bot / 审批助手等' }
        ],
        income: {
            range: '¥ 4,000 – ¥ 18,000 / 月',
            note: '企业效率提升的隐性收益（每月省 ¥ 8-20K 工时）+ 兼职分析 / 咨询 ¥ 2-5K / 项目。',
            sources: [
                '企业内部效率价值：每月省下 ¥ 8,000 – ¥ 20,000 的人力工时',
                '数据分析 / 咨询接单：¥ 2,000 – ¥ 5,000 / 项目',
                '企业 AI 自动化 PoC：¥ 10,000 – ¥ 30,000 / 项目（2026 企业预算重点方向）',
                '行业洞察 / 社群：知识星球 / 小报童 ¥ 99 – ¥ 299 / 年 × 订阅数'
            ]
        }
    }
}

// Weekly hours + scaling multiplier relative to the "base" production
// figures above, which assume ~ 8h / week of focused practice.
const TIME_BUDGET_INFO = {
    tight:  { hours: '≤ 3',   hpw: 3,  mult: 0.45, tag: '碎片化', vibe: '先种下火种 — 3 个月后复盘，产能翻 3 倍都正常。' },
    short:  { hours: '5 – 7', hpw: 6,  mult: 0.85, tag: '稳节奏', vibe: '这是大多数上班族的黄金区间，能稳定产出。' },
    medium: { hours: '8 – 14',hpw: 10, mult: 1.15, tag: '进阶挡', vibe: '已经够产出可变现的作品集，向副业 / 兼职靠拢。' },
    long:   { hours: '15+',   hpw: 18, mult: 1.8,  tag: '全力挡', vibe: '半年内可以把副业做成主业候选。' }
}

// dailyTime is now collected in the base quiz. Round-2 has no time field.
function buildOutcomeHook(answers, extended = {}) {
    const usage = answers.usage || 'writing'
    const hook  = OUTCOME_HOOKS[usage] || OUTCOME_HOOKS.writing
    const timeKey = answers.dailyTime || extended.time || 'short'
    const time  = TIME_BUDGET_INFO[timeKey] || TIME_BUDGET_INFO.short

    const scaled = hook.deliverables.map(d => {
        const q = Math.max(1, Math.round(d.base * time.mult))
        return { ...d, qty: `${q} ${d.unit}`.replace('  ', ' ') }
    })

    return {
        eyebrow:  hook.eyebrow,
        headline: hook.headline,
        subline:  hook.subline,
        timeLabel: `${time.hours} 小时 / 周`,
        timeTag:   time.tag,
        timeVibe:  time.vibe,
        timeFromRound2: !!answers.dailyTime,
        deliverables: scaled,
        income: hook.income
    }
}


// ── Report ID & persistence ───────────────────────────────────────────────
export function generateReportId() {
    const year = new Date().getFullYear()
    const chars = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789'
    let suffix = ''
    for (let i = 0; i < 4; i++) suffix += chars[Math.floor(Math.random() * chars.length)]
    return `AH-${year}-${suffix}`
}

const STORE_KEY = 'aduhelper_reports_v1'

export function saveReportState(id, state) {
    try {
        const all = JSON.parse(localStorage.getItem(STORE_KEY) || '{}')
        all[id] = { ...state, id, updatedAt: new Date().toISOString() }
        localStorage.setItem(STORE_KEY, JSON.stringify(all))
    } catch (e) { console.warn('saveReportState failed', e) }
}

export function loadReportState(id) {
    try {
        const all = JSON.parse(localStorage.getItem(STORE_KEY) || '{}')
        return all[id] || null
    } catch { return null }
}

// ── Remote persistence (server-backed) ─────────────────────────────────────
// Keeps the localStorage path as a cache / offline fallback so the UX never
// breaks if the backend is briefly unreachable.

const API_BASE = '/api/aduhelper'

async function _fetchJson(path, opts = {}) {
    const res = await fetch(`${API_BASE}${path}`, {
        headers: { 'Content-Type': 'application/json', ...(opts.headers || {}) },
        ...opts
    })
    if (!res.ok) {
        const msg = await res.text().catch(() => '')
        throw new Error(`${res.status} ${res.statusText}${msg ? ` — ${msg.slice(0, 160)}` : ''}`)
    }
    const ct = res.headers.get('content-type') || ''
    return ct.includes('application/json') ? res.json() : res.text()
}

/**
 * Save the report both to the server (authoritative) and to localStorage
 * (cache + offline). Fire-and-forget on remote failure, since we don't want
 * a flaky network to block the UI.
 */
export async function saveReportStateSync(id, state) {
    saveReportState(id, state)  // local cache first (fast + resilient)
    try {
        await _fetchJson(`/reports/${encodeURIComponent(id)}`, {
            method: 'PUT',
            body: JSON.stringify({
                answers: state.answers || {},
                extended: state.extended || {},
                freeText: state.freeText || ''
            })
        })
    } catch (e) {
        console.warn('[aduhelper] remote save failed (using local cache):', e.message)
    }
}

/**
 * Try remote first, fall back to localStorage. Returns the hydrated state
 * `{ id, answers, extended, freeText, aiUpgrade }` or null.
 */
export async function loadReportStateSync(id) {
    try {
        const data = await _fetchJson(`/reports/${encodeURIComponent(id)}`)
        if (data && data.id) {
            const normalized = {
                id: data.id,
                answers:  data.answers  || {},
                extended: data.extended || {},
                freeText: data.freeText || data.free_text || '',
                aiUpgrade: data.aiUpgrade || null
            }
            // Refresh local cache so offline still works
            saveReportState(id, normalized)
            return normalized
        }
    } catch (e) {
        if (!/^404/.test(e.message))
            console.warn('[aduhelper] remote load failed, trying local:', e.message)
    }
    return loadReportState(id)
}

/**
 * Ask the server to generate (or return cached) a DeepSeek upgrade plan for
 * this report. Requires round-2 extended answers or freeText to be present.
 * `report` is the full structured report (output of buildReport) — passed so
 * the model can ground its output in the exact tool / version names shown to
 * the user, instead of relying on its (older) training data.
 * Returns the full ReportOut dict on success; throws on error.
 */
export async function upgradeReportRemote(id, { force = false, report = null } = {}) {
    return _fetchJson(`/reports/${encodeURIComponent(id)}/upgrade`, {
        method: 'POST',
        body: JSON.stringify({ force, report })
    })
}

// ── Payment / Premium ──────────────────────────────────────────────────────

/**
 * Create a new payment order (or reuse a still-pending one) for the given
 * report + tier + platform. Server returns `qrCodeUrl` which the client
 * renders into an actual QR image with the `qrcode` npm package.
 */
export async function createPaymentCheckout(reportId, tier, platform) {
    return _fetchJson(`/reports/${encodeURIComponent(reportId)}/checkout`, {
        method: 'POST',
        body: JSON.stringify({ tier, platform })
    })
}

/** Poll order status. PaymentModal uses this on a 2s interval. */
export async function fetchOrderStatus(orderId) {
    return _fetchJson(`/orders/${encodeURIComponent(orderId)}`)
}

/**
 * Fetch the premium payload for a report. Returns a discriminated union:
 *   { paid: true,  payload, tier, platform, vipWechatToken? }
 *   { paid: false, preview, vip: { sold, limit, remaining }, pricing }
 */
export async function fetchPremium(reportId) {
    return _fetchJson(`/reports/${encodeURIComponent(reportId)}/premium`)
}

export async function fetchVipCount() {
    return _fetchJson(`/vip/count`)
}

/** Returns a same-origin URL for the WeChat QR (one-shot token). */
export function vipWechatQrUrl(token) {
    return `${API_BASE}/vip/wechat?token=${encodeURIComponent(token)}`
}

// ── 2026-05-27 新增 · 分析埋点 / 邀请 / 订阅 / Ask / 分享卡 ─────────────

const _SESSION_KEY = 'aduhelper_session_id_v1'
function _sessionId() {
    let sid = ''
    try { sid = localStorage.getItem(_SESSION_KEY) || '' } catch {}
    if (!sid) {
        sid = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`
        try { localStorage.setItem(_SESSION_KEY, sid) } catch {}
    }
    return sid
}

let _trackQueue = []
let _trackFlushTimer = null
function _flushTrackQueue() {
    if (_trackQueue.length === 0) return
    const events = _trackQueue.splice(0, _trackQueue.length)
    const body = JSON.stringify({ session_id: _sessionId(), events })
    // beacon API is fire-and-forget and survives page unload
    if (navigator.sendBeacon) {
        const blob = new Blob([body], { type: 'application/json' })
        navigator.sendBeacon(`${API_BASE}/events`, blob)
    } else {
        fetch(`${API_BASE}/events`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body,
            keepalive: true,
        }).catch(() => {})
    }
}
/** Fire-and-forget event tracker. Batches up to 50 events / 4 s before POSTing. */
export function track(name, props = {}, reportId = '') {
    if (!name || typeof name !== 'string') return
    _trackQueue.push({ name: name.slice(0, 64), props: props || {}, report_id: reportId || '' })
    if (_trackQueue.length >= 20) {
        _flushTrackQueue()
        return
    }
    if (_trackFlushTimer) return
    _trackFlushTimer = setTimeout(() => {
        _trackFlushTimer = null
        _flushTrackQueue()
    }, 4000)
}
if (typeof window !== 'undefined') {
    window.addEventListener('pagehide', _flushTrackQueue)
    window.addEventListener('beforeunload', _flushTrackQueue)
}

/** Ask the Report — paywalled. Throws on 402. */
export async function askReport(reportId, question) {
    return _fetchJson(`/reports/${encodeURIComponent(reportId)}/ask`, {
        method: 'POST',
        body: JSON.stringify({ question }),
    })
}

/** Create / get this report's invite link. */
export async function createInviteLink(reportId) {
    return _fetchJson(`/reports/${encodeURIComponent(reportId)}/invite`, {
        method: 'POST',
        body: '{}',
    })
}

/** Get invite progress for this report. */
export async function fetchInviteStatus(reportId) {
    return _fetchJson(`/reports/${encodeURIComponent(reportId)}/invite-status`)
}

/** Mark a ref token's invite completed (called on new invitee's report save). */
export async function completeInvite(refToken, inviteeReportId) {
    return _fetchJson(`/invites/${encodeURIComponent(refToken)}/complete`, {
        method: 'POST',
        body: JSON.stringify({ invitee_report_id: inviteeReportId }),
    })
}

/** Subscribe to monthly email (gated by inviter's invite-threshold). */
export async function subscribeMonthly(email, inviterReportId) {
    return _fetchJson(`/subscribe`, {
        method: 'POST',
        body: JSON.stringify({ email, inviter_report_id: inviterReportId }),
    })
}

/** Public URL of a report's share card SVG. */
export function shareCardURL(reportId) {
    return `${API_BASE}/reports/${encodeURIComponent(reportId)}/share-card`
}

const _REF_KEY = 'aduhelper_pending_ref_v1'
/** Capture ?ref=<token> from the URL into localStorage if present. */
export function captureRefFromURL() {
    if (typeof window === 'undefined') return null
    try {
        const url = new URL(window.location.href)
        const ref = url.searchParams.get('ref')
        if (ref && /^[A-Za-z0-9_-]{8,32}$/.test(ref)) {
            localStorage.setItem(_REF_KEY, ref)
            // Fire-and-forget visit log
            fetch(`${API_BASE}/invites/${encodeURIComponent(ref)}/visit`, { method: 'GET' }).catch(() => {})
            // Clean the URL so reloads don't re-attribute
            url.searchParams.delete('ref')
            window.history.replaceState({}, '', url.toString())
            return ref
        }
        return localStorage.getItem(_REF_KEY) || null
    } catch { return null }
}

/** Consume any pending ref from localStorage and call complete-invite. */
export async function consumePendingRef(inviteeReportId) {
    let ref = null
    try { ref = localStorage.getItem(_REF_KEY) } catch {}
    if (!ref) return null
    try {
        const res = await completeInvite(ref, inviteeReportId)
        // Only remove the ref if the complete was successful (or already-completed)
        try { localStorage.removeItem(_REF_KEY) } catch {}
        return res
    } catch (e) {
        console.warn('[aduhelper] completeInvite failed:', e.message)
        return null
    }
}

// ── Profile summary: turn answer codes into human labels ───────────────────
const ANSWER_LABELS = {
    usage:     { writing:'写作表达', coding:'编程开发', design:'设计创作', data:'数据分析' },
    learning:  { video:'视频教程', docs:'官方文档', hands:'动手实战', community:'社群交流' },
    identity:  { dev:'开发者', creative:'创意工作者', business:'商务 / 职场', student:'学生' },
    dailyTime: { tight:'不到 30 分钟 / 天', short:'30 - 60 分钟 / 天', medium:'1 - 2 小时 / 天', long:'2 小时以上 / 天' },
    realTask:  { improve:'改造手头工作', build:'做一个小项目', create:'产出一组作品', learn:'从零学懂一个领域' }
}

function buildProfile(answers) {
    return [
        { label: '主要用途', value: ANSWER_LABELS.usage[answers.usage]         || '—' },
        { label: '学习方式', value: ANSWER_LABELS.learning[answers.learning]   || '—' },
        { label: '身份定位', value: ANSWER_LABELS.identity[answers.identity]   || '—' },
        { label: '每日投入', value: ANSWER_LABELS.dailyTime[answers.dailyTime] || '—' },
        { label: '真实任务', value: ANSWER_LABELS.realTask[answers.realTask]   || '—' }
    ]
}

// ── AI 原理科普 · 一篇看完就懂当代 AI 是怎么回事 ────────────────────────────
// Beginner-targeted explainers. 每条遵循: 1 句俗语类比 + 1 段稍长解释 + 一条
// 「常见误区」让人秒懂边界。读完这一节就能听懂 AI 圈 90% 的术语。
const AI_PRIMER = [
    {
        emoji: '🧠',
        term: '大语言模型 (LLM)',
        analogy: '想象一个把全网文字都背熟了的「猜词高手」—— 它每次只回答"下一个字最有可能是什么"。',
        body: 'LLM = Large Language Model。本质是一个超大的概率函数：给定一段输入，预测最可能的下一个 token。Claude、GPT、DeepSeek、Kimi、GLM 都是这个机制，只是规模、训练数据、对齐方式不同。',
        misconception: '不是数据库。它"记忆"的是统计规律不是事实，所以会一本正经地编造（hallucination）。',
        quiz: {
            q: '下面哪一项最准确地描述了 LLM 的工作原理？',
            options: [
                '查询内置数据库返回最匹配的事实',
                '基于概率函数，预测最可能的下一个 token',
                '完全等同于人脑思考，能做真正的推理',
                '只对训练过的语种有效，新语言完全失效'
            ],
            answer: 1,
            why: 'LLM 是统计概率函数，"记忆"的是规律不是事实——所以它会幻觉，也才需要 RAG 给它"开卷资料"。'
        }
    },
    {
        emoji: '🔤',
        term: 'Token',
        analogy: 'AI 看世界的"字"。中文 1 字 ≈ 1 token，英文 1 个常见词 ≈ 1.3 token，标点空格也算。',
        body: '所有现代 LLM 的输入输出都按 token 计费 + 计长度。1M 上下文 ≈ 75 万英文词 ≈ 50 万汉字 ≈ 一本《红楼梦》。算成本时永远按 token 不按字符。',
        misconception: '"我只发了一句话怎么扣这么多 token？" — 系统 prompt + 历史对话 + 上传的图都计入。',
        quiz: {
            q: '"我就发了一句 5 个字的话，为什么 API 显示用了 800 token？"——最可能的原因是？',
            options: [
                'API 计费有 bug',
                '系统 prompt + 历史对话 + 附件全都计入',
                '中文统计方法不同，1 字算 100 token',
                '5 个字本身就要花 800 token'
            ],
            answer: 1,
            why: '每次调用 LLM 都会带上 system prompt、对话历史、附件 / 图片，这些都按 token 计费——所以"小问题大开销"是常见误区。'
        }
    },
    {
        emoji: '🔧',
        term: 'Transformer 与注意力机制',
        analogy: '一群分组讨论的同事 —— 每个词都同时偷瞄全班所有词，再决定自己该被理解成什么意思。',
        body: 'Transformer 2017 由 Google 提出，至今仍是所有大模型的骨架。核心是 self-attention：让每个 token 都能动态参考所有其他 token 的信息。所以"上下文"越长，理解越准 —— 但算力开销也是平方级。',
        misconception: '注意力 ≠ 思考。Reasoning model（Opus 4.7 / GPT-5.5 Pro）是在标准 Transformer 上额外加了"先想再答"的训练目标。',
        quiz: {
            q: '关于 Transformer 的 self-attention 机制，下列说法哪个是正确的？',
            options: [
                '每个 token 只能参考它前面的 token',
                '每个 token 可以动态参考其他所有 token，但算力开销是 N² 级',
                'attention 等同于人类的"思考"，是 reasoning model 的全部',
                '上下文长度无限增长不会影响成本'
            ],
            answer: 1,
            why: 'self-attention 让每个 token 都能"偷瞄"其它所有 token，但代价是 N² 算力。这就是为什么超长上下文又贵又慢。'
        }
    },
    {
        emoji: '🎯',
        term: '预训练 vs 后训练 (RLHF / DPO)',
        analogy: '预训练 = 上学背书；后训练 = 实习时被师傅手把手纠正"该怎么对人说话"。',
        body: '预训练让模型学会语言本身，后训练让它学会"按人类期望回答"。Anthropic 的 Constitutional AI、OpenAI 的 RLHF、DeepSeek 的 RL + GRPO 都是后训练手段。同样的 base model，不同后训练能产出风格完全不同的助手。',
        misconception: '换 prompt 风格不等于改了模型。后训练是"刻在底层 weights 里的"。',
        quiz: {
            q: '同一个 base model，不同公司做出来的助手风格差别巨大——根本原因是？',
            options: [
                '它们其实用了不同的 base model，只是名字一样',
                '前端 prompt 不一样',
                '后训练阶段（RLHF / Constitutional AI / GRPO）目标不同',
                '调用的硬件不同'
            ],
            answer: 2,
            why: '后训练是把"该怎么回答"刻进 weights 的过程。同样的预训练底子，配不同后训练就是不同性格的助手。'
        }
    },
    {
        emoji: '🪟',
        term: 'Context window（上下文窗口）',
        analogy: '一次对话的"短期记忆"。窗口里所有内容都看得见，超出就丢。',
        body: '2026 主流：Claude 4.7 / GPT-5.5 / DeepSeek V4 / Gemini 3.5 Flash / 3.1 Pro 全部 1M；Kimi K2.6 262K；GLM-5.2 1M。够塞整本书 + 完整代码仓 + 几小时录音。',
        misconception: '窗口大 ≠ 注意力均匀。中段内容容易被"中间被遗忘"（Lost in the Middle），重要信息放头尾更稳。',
        quiz: {
            q: '1M 上下文窗口下，把关键资料放在哪里效果最稳？',
            options: [
                '中间部分，前后包夹更安全',
                '随便放，因为窗口大注意力是均匀的',
                '靠近开头或结尾，避免"Lost in the Middle"效应',
                '只能放在系统 prompt 里'
            ],
            answer: 2,
            why: '即便有 1M 上下文，中段信息也容易被遗忘——这是 Anthropic / OpenAI 都验证过的现象。重要内容靠头或靠尾更稳。'
        }
    },
    {
        emoji: '🌫️',
        term: 'Hallucination（幻觉）',
        analogy: 'AI 自信地胡说八道。尤其爱编造数字、论文标题、代码 API 名。',
        body: '根因是 LLM 永远在"生成最可能的字"，而不是"查证事实"。GPT-5.5 Instant 比 5.3 在医法金高风险场景幻觉率降了 52.5%，但 0% 不可能。',
        misconception: '加一句"不要胡说"没用。用 RAG / 联网搜索 / 让它输出引用 + 自评置信度，才是真解药。',
        quiz: {
            q: '下面哪种做法最能可靠地降低 AI 的事实性幻觉？',
            options: [
                '在 prompt 里加一句"不要胡说八道"',
                '提高温度 (temperature)',
                '用 RAG 给它资料 + 让它输出引用 + 自评置信度',
                '让它多输出几遍，少数服从多数'
            ],
            answer: 2,
            why: '幻觉的根因是 LLM 在"猜词"而不是"查证"。开卷（RAG）+ 引用 + 自评置信度是工程上最有效的组合。'
        }
    },
    {
        emoji: '📚',
        term: 'RAG（检索增强生成）',
        analogy: '考试前给 AI 发"开卷资料"。先检索相关段落，再让模型基于这些段落作答。',
        body: '2026 企业 AI 的主流落地姿势。流程：你的资料 → 切片 + 向量化 → 存进向量库 → 用户提问 → 检索相关段 → 拼进 prompt → 模型生成。开源代表：LlamaIndex / LangChain / Dify / Haystack。',
        misconception: 'RAG 不是 fine-tuning。前者每次都查；后者把知识"焊"进 weights。多数人 RAG + prompt 就够了，别上 fine-tuning。',
        quiz: {
            q: 'RAG 和 fine-tuning 的根本差别是？',
            options: [
                '是同一种技术的两种叫法',
                'RAG 每次都查外部资料；fine-tuning 把知识改写进模型 weights',
                'RAG 只能用闭源模型；fine-tuning 只能用开源',
                'RAG 要 GPU；fine-tuning 不需要'
            ],
            answer: 1,
            why: 'RAG = 开卷考试（每次查资料），fine-tuning = 把知识焊进 weights。多数场景 RAG + 好 prompt 就够，不必上 fine-tuning 的复杂度。'
        }
    },
    {
        emoji: '🦾',
        term: 'Agent（代理）',
        analogy: '不只是"答问题"，而是能"自己想 → 调工具 → 看结果 → 再想"循环跑下去的 AI。',
        body: '2026 代表：Claude Code Agent view + /goal、Cursor 3.3 "Build in Parallel"、Manus My Computer 桌面 Agent、Kimi 300-Agent 集群、GLM-5.2 8 小时自主编程。Agent = LLM + Tool use + 规划循环 + 记忆。',
        misconception: 'Agent 越自主越好？不。多步任务里每一步都可能错，错误会复利放大。要给 step / time budget + 关键操作人审。',
        quiz: {
            q: '让 Agent 跑长任务时最该做的"避坑"是？',
            options: [
                '把 step budget 调到无限，让它跑到底',
                '不要给任何约束，AI 自己最聪明',
                '设 step / time budget + 关键操作（写文件 / 网络请求）人审',
                '关掉所有工具，只让它答问题'
            ],
            answer: 2,
            why: '多步任务里每一步都可能出错，错误会复利放大。预算 + 人审关键点是 2026 工业级 Agent 的标准做法。'
        }
    },
    {
        emoji: '🔌',
        term: 'MCP（Model Context Protocol）',
        analogy: 'AI 圈的 USB-C —— 一次接好"文件 / GitHub / 数据库"，所有 AI 客户端通用。',
        body: 'Anthropic 2024 提出，2025/12 已捐给 Linux Foundation 的 Agentic AI Foundation。月装机量 9700 万 + 200+ 官方 server。Claude / Cursor / OpenAI / Microsoft / Google 已全部支持。',
        misconception: 'MCP 不是模型的能力，是协议。装一个 MCP server 等于给 AI 多开一扇"工具门"。',
        quiz: {
            q: '下面哪个说法对 MCP 来说是正确的？',
            options: [
                'MCP 是 Anthropic 闭源专有的，只 Claude 能用',
                'MCP 是一种新的大模型，比 Claude 4.7 更强',
                'MCP 是开放协议，Claude / Cursor / OpenAI / Google 等都已支持',
                'MCP 装好就能让模型变聪明'
            ],
            answer: 2,
            why: 'MCP 是协议，不是模型能力。它已被 Linux Foundation 接手，目前主流 AI 客户端都已支持——相当于 AI 工具的 USB-C 接口。'
        }
    },
    {
        emoji: '🛠️',
        term: 'Tool use / Function calling',
        analogy: 'AI 不再"光说不练"——它能主动判断"这个问题需要查数据库"，然后真的去调 API。',
        body: 'Tool use 是 Agent 的基石。模型在生成时判断需要外部工具，输出一个结构化调用，运行时执行后把结果回喂给模型，再继续生成。Anthropic、OpenAI、Google 的 tool use API 已经互相兼容。',
        misconception: '"AI 自己上网了"不一定靠 tool use；很多产品其实是 RAG 或代理脚本套壳。看接口字段 (tool_use / function_call) 才作数。',
        quiz: {
            q: 'Tool use（函数调用）和 RAG 的本质区别是？',
            options: [
                '两者是同一件事',
                'Tool use 由模型在生成中自主决定何时调用外部工具；RAG 是固定的"先查后答"管线',
                'Tool use 只能调本地函数，不能联网',
                'RAG 比 Tool use 更先进，是它的升级版'
            ],
            answer: 1,
            why: 'Tool use 是模型在每一步自主决定"该不该 / 该调哪个工具"；RAG 是固定流程"先检索再回答"。Agent 必然要靠 tool use 才能多步自主。'
        }
    },
    {
        emoji: '🧪',
        term: 'Reasoning / Thinking 模型',
        analogy: '答题前先在草稿纸上推一遍。Opus 4.7、GPT-5.5 Pro、Gemini 3.1 Pro 默认开"思考"档。',
        body: '比传统 LLM 多一步：先生成大段"内心独白"（chain of thought），再基于它输出最终答案。在数学、编程、长链推理任务上提升明显。代价：贵 2-10 倍 + 慢。',
        misconception: '"让它想久点更准"——超过任务复杂度后会反向劣化（过度思考），简单任务用 Sonnet/Flash 就够。',
        quiz: {
            q: '一段需要分类邮件的简单任务，选哪个模型最合理？',
            options: [
                'Opus 4.7 + 最大思考档，宁多勿少',
                'GPT-5.5 Pro 开 xhigh',
                'Sonnet 4.6 或 Haiku 4.5 / Flash 这类轻量档',
                '什么模型都行，反正都能做对'
            ],
            answer: 2,
            why: 'Reasoning 模型贵 2-10 倍、还慢，简单任务用它是浪费且会"过度思考"。简单分类 / 摘要 / 改写——Haiku / Sonnet / Flash 就够。'
        }
    },
    {
        emoji: '🧩',
        term: 'MoE（混合专家）',
        analogy: '一个公司里有 100 位专家，每次只叫最相关的 2-3 位上来答 —— 看起来"全员动员"实际只用一小部分参数。',
        body: '让 1.6T 参数的大模型在推理时只激活 49B。代表：DeepSeek V4-Pro 1.6T / 49B、Kimi K2.6 1T / 32B、GLM-5.2 744B / 40B、Qwen 3.7-Max。优势：性价比高、速度快。',
        misconception: 'MoE 不是"分布式"也不是"集成模型"。它是单一神经网络内部的稀疏激活机制。',
        quiz: {
            q: 'DeepSeek V4-Pro 标 "1.6T / 49B 激活" 是什么意思？',
            options: [
                '总共 1.6T 参数，但单次推理只激活 49B 子集',
                '需要 1.6TB 显存才能跑',
                '每秒 1.6T 次运算',
                '49B 是它的训练成本（美元）'
            ],
            answer: 0,
            why: 'MoE 让大模型在"装得下知识"和"跑得动"间取得平衡：总参数巨大，但每个 token 只调用一小撮"专家"参数。'
        }
    },
    {
        emoji: '🎨',
        term: 'Multimodal（多模态）',
        analogy: '同一个模型同时看图、听语音、看视频、读文字 —— 真正的"通才大脑"。',
        body: '2026 视频模型已能同步出音轨：Gemini Omni / Seedance 2 / 可灵 3 / Runway Gen-4.5。图像模型已能精准渲染文字：Nano Banana Pro / Midjourney v8.1。多模态 LLM（Claude / Gemini / Qwen / Kimi）能直接看截图答 UI 问题。',
        misconception: '"多模态"不等于"全能"。看图能力强不代表生成图能力强；做工具时要分开评测。',
        quiz: {
            q: '一个模型在"看截图答 UI 问题"上很强，那它生成图的能力一定也强吗？',
            options: [
                '一定，多模态 = 全能',
                '不一定。看图和生图是两套独立能力，要分开评测',
                '一定不强，看图强必然生图弱',
                '看模型大小：参数越多就越全能'
            ],
            answer: 1,
            why: '"多模态"只是"能处理多种模态"，每种模态的强弱要单独看 benchmark。Claude 能看图但不能生图；Midjourney 能生图但不太能看图。'
        }
    },
    {
        emoji: '🌍',
        term: '开源 vs 闭源',
        analogy: '闭源像云端打车，方便贵；开源像自己买车，麻烦但完全可控。',
        body: '2026 开源已大幅追上：DeepSeek V4 (MIT)、GLM-5.2 (MIT)、Kimi K2.6、Qwen 3.6、Flux 2 Klein (Apache 2.0)。开源代表"可下载、可微调、可本地部署、可商用"。开源不等于"任何人都能用"——600B+ 的模型多数人本地跑不动。',
        misconception: '"开源就免费"——硬件、电费、运维都是真金白银。多数中小团队仍是 API 优先。',
        quiz: {
            q: '小团队上线一个 AI 客服，目前最务实的选择是？',
            options: [
                '自己买 H100 跑开源 1.6T 模型，长期省钱',
                '从一开始就 fine-tuning 一个开源 70B',
                '先用 API（DeepSeek / Claude / GPT）+ RAG + prompt 上线，把功夫花在产品和数据',
                '等"开源完全免费"那天再做'
            ],
            answer: 2,
            why: '"开源 ≠ 免费"。中小团队自托管 600B 模型的硬件 + 电 + 运维成本远高于直接调 API。API + RAG + prompt 是 2026 大多数团队的最优解。'
        }
    },
    {
        emoji: '🛡️',
        term: 'Guardrail / 对齐',
        analogy: '给 AI 装的护栏 —— 防止它输出违规、越权、虚构、被 prompt injection 劫持。',
        body: '上生产必备：输入侧（prompt 注入检测、敏感词、PII 脱敏）+ 输出侧（事实核查、政策检查、人审兜底）。常用工具：Anthropic Claude policy、OpenAI Moderation API、Llama Guard、Lakera AI。',
        misconception: '"加一段 system prompt 不要做坏事"是最弱的护栏。专业护栏要走独立模型 / 服务，不能全靠主 LLM 自觉。',
        quiz: {
            q: '生产环境最弱的"护栏"做法是哪个？',
            options: [
                '输入侧 PII 脱敏 + prompt 注入检测',
                '只在 system prompt 写一句"请不要做坏事"',
                '输出侧加 moderation 检查 + 关键操作人审',
                '用 Llama Guard / Lakera 这样的独立护栏模型'
            ],
            answer: 1,
            why: '主 LLM 的"自觉"完全不够——专业护栏要靠独立模型 / 服务在输入侧 + 输出侧两端守门。'
        }
    },
    {
        emoji: '⚡',
        term: 'Inference 成本与延迟',
        analogy: '点单 vs 等菜：上下文越长 (输入 token 越多) 第一口饭来得越慢；输出越长，整顿饭吃越慢。',
        body: '2026 三类优化：① Prompt cache（重复 prompt 命中缓存，便宜 90%，Anthropic / DeepSeek 都支持）② 流式输出（边想边出，体感更快）③ MoE / 量化 / FP8（让大模型变快）。要算账先看 input vs output token 比例。',
        misconception: '"模型越大越好"——延迟敏感场景（聊天 / IDE 补全）要选 Haiku 4.5 / Gemini Flash / DeepSeek V4-Flash。',
        quiz: {
            q: '你写了一个客服聊天机器人，每次都附上几千 token 的相同 system prompt + FAQ——下一步最该做的优化是？',
            options: [
                '换成 Opus 4.7 拒绝省钱',
                '把所有 FAQ 改成 fine-tuning 进模型',
                '启用 Prompt cache，重复的 prompt 部分自动便宜 90%',
                '把上下文窗口换到 200K 以下'
            ],
            answer: 2,
            why: 'Prompt cache（Anthropic / DeepSeek 都已支持）专治这种"前缀重复"场景——重复 token 的费用降 90%、首字延迟也降。'
        }
    }
]

// ── 2026 AI 技术全景图 · 五层立体视角 ─────────────────────────────────────
// Selectively curated — 每层只列 2026/5 各赛道前 3 名 + 一句"何时选谁"。
const TECH_MAP = [
    {
        layer: 'L1 · 基础大模型',
        emoji: '🧠',
        oneLiner: '所有 AI 应用的"芯片"——选错主力，后面全部白搭。',
        rows: [
            { name: 'Claude Opus 4.7 / Sonnet 4.6', when: '默认主力。Opus 4.7 已升 1M 上下文 + 高分辨率视觉；日常任务用 Sonnet（已比上代 Opus 还强）。' },
            { name: 'GPT-5.5 Instant / Pro',         when: '生态最广（ChatGPT 主力）；5/5 起 Instant 成默认 + 跨对话记忆；Pro 适合多步乱糟糟任务。' },
            { name: 'Gemini 3.5 Flash / 3.1 Pro',     when: '原生多模态 + 1M 上下文 + Google 全家桶；5/19 Flash GA 已超 3.1 Pro，3.5 Pro 跳票至 7 月（限 Vertex 预览）。' },
            { name: 'DeepSeek V4-Pro / Flash',        when: 'API 最便宜的前沿（5/22 起 V4-Pro $0.435 入 · $0.87 出 / M），开源 MIT，可本地部署。' },
            { name: 'GLM-5.2',                        when: '国产开源旗舰（6/13），744B MoE + 1M 上下文 + 8 小时自主编程；智能指数 51 超 DeepSeek V4 Pro / Kimi K2.6，MIT。' },
            { name: 'Kimi K2.6 · Qwen 3.7-Max',       when: '中文场景首选；Kimi 适合长文档 / Agent 集群（6/12 加 K2.7-Code），Qwen 3.7-Max 1M 上下文 + 35 小时自主。' }
        ]
    },
    {
        layer: 'L2 · 编程 / Agent 工作台',
        emoji: '💻',
        oneLiner: '把基础模型变成"能干活的同事"。2026 已形成 Cursor + Claude Code + Codex 的可组合栈。',
        rows: [
            { name: 'Cursor',         when: '日常 IDE。2026/6/22 升 3.9：Customize 面板统管 plugins / skills / MCP / subagents；云端 Agent <10 分钟搭环境 + Auto-review 安全分级。' },
            { name: 'Claude Code',    when: '终端原生 Agent，2026/5 加 Agent view + /goal 跨轮任务 + Plugin marketplace；占公开 GitHub 提交 4%。' },
            { name: 'OpenAI Codex (CLI)', when: '可作为 Claude Code 的 reviewer (/codex:adversarial-review)；对抗式审查独门。' },
            { name: 'v0.app · Bolt.new · Lovable', when: '不写代码做产品。v0 React 优；Bolt WebContainer 全栈；Lovable 适合非技术人。' },
            { name: 'Replit Agent · Windsurf',     when: 'Replit 移动端 / 部署一体；Windsurf 由 Devin 团队出品，Cascade 模式。' }
        ]
    },
    {
        layer: 'L3 · 多模态生成（图 / 视频 / 音）',
        emoji: '🎨',
        oneLiner: '2026 视频年。一支 30 秒短视频成本从几千降到几十块，但单价反向涨。',
        rows: [
            { name: '图像 · Midjourney v8.1',      when: '艺术性 + 风格一致性最强；--hd 默认 2K，5× 速度。' },
            { name: '图像 · Nano Banana Pro',      when: '14 张参考图 + 多语言文字渲染最强；做信息图 / 海报首选。' },
            { name: '图像 · Seedream 5.0',         when: '中文 prompt + 国风元素首选；免费额度大。' },
            { name: '图像 · Flux 2 (Klein/Pro)',   when: '想自部署 / 接 ComfyUI / LoRA 工作流，Klein 是 Apache 2.0。' },
            { name: '视频 · Gemini Omni / Google Flow', when: '2026/5/19 I/O 发布，Veo 已并入 Flow；Omni 一次吃文/图/音/视频，出 10s 同步音轨片段。' },
            { name: '视频 · Seedance 2.5',         when: '6/23 发布：30 秒一镜到底 + 4K + 50 张参考图，企业 beta、7 月初公开；2.0 已升 4K。' },
            { name: '视频 · 可灵 3.0 / Turbo',     when: '4 模型矩阵；6/17 加 3.0 Turbo（更快更省 + vCoT）；多语种唇同步最稳，全球用户破 1 亿。' },
            { name: '视频 · Runway Gen-4.5',       when: '2026/5/3 原生音轨 + 参考图条件锁定主体；5/13 Runway Agent 对话式剪辑。' },
            { name: '音频 · Suno v5.5',            when: '可用 Voices 把自己嗓音克隆进歌曲；Custom Models 学个人风格。' },
            { name: '音频 · ElevenLabs v3 + Music v2', when: '6 月 Music v2（分段控制 + 曲风中途切换）；70+ 语言克隆 + 商用授权；ElevenMusic iOS。' }
        ]
    },
    {
        layer: 'L4 · Agent / 自动化 / 编排',
        emoji: '🤖',
        oneLiner: '把 AI 嵌入流程，不只用 AI 答问题。',
        rows: [
            { name: 'Manus · My Computer',  when: '桌面 Agent 可读写本机文件、控制应用、几分钟造小 app；Meta $2B 收购被阻，6/11 运营拆分完成，6/18 创始团队拟原价回购，ARR $4.5 亿。' },
            { name: 'Zapier AI Agents',     when: '6000+ 应用接入，零代码搭 AI 工作流，业务岗首选。' },
            { name: 'n8n',                  when: '开源、自部署、支持 MCP + LLM 节点，技术岗最爱。' },
            { name: 'Dify',                 when: '国内团队最爱，开源 LLM 应用平台，含 RAG / Agent / 工作流。' },
            { name: 'Make.com',             when: '场景复杂的多步可视化自动化。' },
            { name: 'Custom GPTs / Claude Projects', when: '小团队最轻的"私人 AI 工具"姿势，不需要写代码。' }
        ]
    },
    {
        layer: 'L5 · 基础设施 / 协议 / 开源生态',
        emoji: '🔌',
        oneLiner: '2026 已经成熟。MCP 是事实标准；推理基建竞争白热化。',
        rows: [
            { name: 'MCP (Model Context Protocol)', when: 'AI 工具协议事实标准。已捐给 Linux Foundation；月装机 9700 万 + 200 server。' },
            { name: '推理 · vLLM / SGLang / TensorRT-LLM', when: '本地 / 自托管推理三大栈；FP8 量化已成主流。' },
            { name: '向量库 · pgvector / Qdrant / Milvus', when: 'RAG 必备；pgvector 适合已有 Postgres，Qdrant 性能口碑佳。' },
            { name: '应用框架 · LangChain / LlamaIndex / Haystack', when: '快速搭 RAG / Agent；2026 趋势是更轻的 SDK + MCP 集成。' },
            { name: '可观测 · LangSmith / Phoenix / Helicone', when: '生产 AI 必装：trace / 成本 / 评测 / 错误回放。' }
        ]
    }
]

// ── 学习路径 · 30 / 60 / 90 天 milestones + 长期资源池 ────────────────────
// 让初学者读完报告就有"明天起到三个月该看什么 / 做什么"。
const LEARNING_PATH = {
    milestones: [
        { at: '第 7 天',  goal: '把 AI 接进 1 个真实场景（写作 / 编程 / 设计 / 数据任选 1）', signal: '能讲清楚"它替我省了 X 分钟、它做错了 Y 点"' },
        { at: '第 30 天', goal: '把 AI 嵌入工作流主线，建立 10+ 条个人 prompt 模板',          signal: '同事看你产出会问"怎么做到的"' },
        { at: '第 60 天', goal: '上手 1 个 API / Agent / 自动化 —— 让 AI 自动跑你的小工作', signal: '至少 1 个流程"我不在它也跑"' },
        { at: '第 90 天', goal: '产出 1 个公开作品（文章 / 网站 / 视频 / 工具），有真实用户', signal: '收到至少 3 条来自陌生人的反馈' },
        { at: '半年',     goal: '形成"AI-native"工作方式 —— 每天默认有 AI 协作',              signal: '回望 6 个月前自己的产出，感觉像两个人' }
    ],
    free: [
        { kind: '官方文档', items: [
            { name: 'Anthropic 官方教程',  url: 'https://docs.claude.com',                      tip: '从 Quickstart → Tool use → Prompt caching → Agents 一条龙读完' },
            { name: 'OpenAI Cookbook',     url: 'https://cookbook.openai.com',                  tip: '示例最丰富，从 RAG 到 Agent 都有可跑代码' },
            { name: 'Google AI Studio + Gemini API', url: 'https://ai.google.dev',              tip: '免费额度大方，玩多模态 / 长视频 / Live API 首选' },
            { name: 'DeepSeek API Docs',   url: 'https://api-docs.deepseek.com',                tip: '中文友好 + 价格透明 + 含 prompt cache' },
            { name: 'MCP 官方文档',         url: 'https://modelcontextprotocol.io',              tip: '看一遍 spec → 装一个 server → 自己写一个 server，AI 工具能力立刻翻倍' }
        ]},
        { kind: '免费课程', items: [
            { name: 'Andrej Karpathy · Neural Networks: Zero to Hero', url: 'https://karpathy.ai/zero-to-hero.html', tip: '从矩阵乘法手撸到 GPT-2，看完 LLM 在你心里就不是黑盒' },
            { name: '李宏毅 · 机器学习 / 大模型课',  url: 'https://speech.ee.ntu.edu.tw/~hylee/genai/2025-spring.php', tip: '2025 春季最新版，中文最好的入门课，B 站有镜像' },
            { name: 'DeepLearning.AI Short Courses', url: 'https://learn.deeplearning.ai',                          tip: 'Andrew Ng 团队 + 各大模型公司联出，每门 1 小时实战，免费' },
            { name: 'Anthropic Courses',              url: 'https://github.com/anthropics/courses',                  tip: 'Anthropic 官方的 prompt engineering / API 课程，含 Jupyter' },
            { name: 'Hugging Face LLM / Agents Course', url: 'https://huggingface.co/learn',                          tip: '开源模型 / Agents / 多模态全覆盖，做笔记式课程' }
        ]},
        { kind: '论文 & 综述（按读完性价比排）', items: [
            { name: 'Attention Is All You Need (Vaswani 2017)',   url: 'https://arxiv.org/abs/1706.03762',          tip: 'Transformer 起点。读不懂没关系，记住"自注意力"四个字' },
            { name: 'GPT-3 (Brown 2020)',                         url: 'https://arxiv.org/abs/2005.14165',          tip: '"Few-shot 学习"概念发源，引出 prompt engineering 整个学科' },
            { name: 'InstructGPT / RLHF (Ouyang 2022)',           url: 'https://arxiv.org/abs/2203.02155',          tip: '为什么 ChatGPT 比 GPT-3 听话？答案在这' },
            { name: 'Constitutional AI (Anthropic 2022)',         url: 'https://arxiv.org/abs/2212.08073',          tip: 'Claude 的对齐方法，理解 RLHF 的另一条路' },
            { name: 'DeepSeek-V3 / R1 / V4 报告',                  url: 'https://github.com/deepseek-ai',            tip: '2024-26 开源 LLM 工程化最透明的一手资料' }
        ]},
        { kind: '中文社区 / 大牛博客', items: [
            { name: 'Datawhale',                  url: 'https://datawhale.cn',                         tip: '国内最活跃的开源 AI 学习社区，组队学课 + 国产实战教程' },
            { name: '量子位 · 机器之心',          url: 'https://www.jiqizhixin.com',                   tip: '国内 AI 资讯最快的两家；订阅日报 5 分钟看完今日动态' },
            { name: '即刻 · AI 圈 / 小红书 #AI',  url: 'https://web.okjike.com',                       tip: '一手玩家 / 独立开发者最活跃的两个广场' },
            { name: 'Simon Willison',             url: 'https://simonwillison.net',                    tip: '英文圈 LLM 实战大牛，几乎每天有新发现' },
            { name: 'Karpathy · X / 视频',        url: 'https://x.com/karpathy',                       tip: '最有耐心讲底层原理的人；他每发一条视频都值得停下其他工作看完' }
        ]}
    ],
    practice: [
        '每周写 1 条"翻车日记"：哪个 prompt 没成、根因是什么、改完版本是什么',
        '每月跑 1 次"工具复盘"：3 个新工具试过即留即弃；只保留过去 30 天真用过的',
        '每季度做 1 个能拿出手的小作品（网站 / 文章系列 / 视频 / 工具），强制公开',
        '订阅 1-2 份英文 AI Newsletter（如 The Batch / Last Week in AI / Latent Space）'
    ]
}

// ── Main build ─────────────────────────────────────────────────────────────
export function buildReport(answers, extended = {}, freeText = '') {
    const persona = PERSONAS[answers.identity] || PERSONAS.student
    // Report is positioned from a beginner baseline — level is the "入门" meta
    // regardless of answers, per product direction.
    const level   = LEVEL_META.never
    const tip     = LEARNING_TIPS[answers.learning] || LEARNING_TIPS.hands
    const agents  = pickAgents(answers)
    const projects = pickProjects(answers)
    const skills  = pickSkills(answers)
    const steps   = buildSteps(answers)
    const profile = buildProfile(answers)
    const templateKey = TEMPLATE_KEY_BY_USAGE[answers.usage] || 'prompt'
    const template = PROMPT_TEMPLATES[templateKey]
    const pitfalls = PITFALLS[answers.identity] || PITFALLS.student

    // timePlan is now driven by the base-quiz dailyTime answer; round-2 only
    // carries blocker + horizon.
    const timeKey   = answers.dailyTime || extended.time || null
    const timePlan  = timeKey          ? TIME_PLANS[timeKey]                  : null
    const blocker   = extended.blocker ? BLOCKER_REMEDIES[extended.blocker]   : null
    const horizon   = extended.horizon ? HORIZON_MILESTONES[extended.horizon] : null

    // Expanded: fast win for first hour, 4-week plan, productivity ladder,
    // key concepts, current model snapshot.
    const fastWin      = FAST_WINS[answers.usage]       || FAST_WINS.writing
    const fourWeekPlan = FOUR_WEEK_PLAN[answers.identity] || FOUR_WEEK_PLAN.business
    const ladder       = PRODUCTIVITY_LADDER.never
    const concepts     = KEY_CONCEPTS
    const modelSnapshot = MODEL_SNAPSHOT

    // 2026-05 升级：原理科普 / 技术全景 / 学习路径 三大新章节，目标是
    // "一个报告读完就能掌握当前最新 AI"——免费版也带，入门用户最受益。
    const aiPrimer     = AI_PRIMER
    const techMap      = TECH_MAP
    const learningPath = LEARNING_PATH

    const outcomeHook = buildOutcomeHook(answers, extended)

    return {
        persona, level, tip, agents, projects, skills, steps, profile,
        template, pitfalls,
        timePlan, blocker, horizon,
        fastWin, fourWeekPlan, ladder, concepts, modelSnapshot,
        aiPrimer, techMap, learningPath,
        outcomeHook,
        freeText: (freeText || '').trim()
    }
}

// ── Markdown export ────────────────────────────────────────────────────────
export function reportToMarkdown(id, data, answers, extended = {}) {
    const now = new Date().toLocaleDateString('zh-CN')
    const lines = []
    lines.push(`# ADu Helper · 专属 AI 入门报告`)
    lines.push(``)
    lines.push(`- 报告编号：**${id}**`)
    lines.push(`- 生成日期：${now}`)
    lines.push(`- 画像标签：${data.level.tag} · ${data.persona.tag}`)
    lines.push(`- 数据时效：所收录的工具、技能与开源项目均更新至 **${now}**，覆盖当周最新的 AI 模型版本与生态趋势。`)
    lines.push(``)
    if (data.outcomeHook) {
        const h = data.outcomeHook
        lines.push(`## 🚀 你的 AI 收益蓝图`)
        lines.push(`> ${h.eyebrow}`)
        lines.push(``)
        lines.push(`**${h.headline}**`)
        lines.push(``)
        lines.push(h.subline)
        lines.push(``)
        lines.push(`- ⏱ 投入节奏：**${h.timeLabel}** · ${h.timeTag}${h.timeFromRound2 ? '' : '（默认估算，填完 round 2 会更准）'}`)
        lines.push(`- 💡 ${h.timeVibe}`)
        lines.push(``)
        lines.push(`**预计每月可产出：**`)
        for (const d of h.deliverables) lines.push(`- ${d.icon} ${d.title} · **${d.qty}**（${d.note}）`)
        lines.push(``)
        lines.push(`**现实变现区间：${h.income.range}**`)
        lines.push(h.income.note)
        for (const s of h.income.sources) lines.push(`- ${s}`)
        lines.push(``)
    }
    lines.push(`## 一、你的画像`)
    for (const p of data.profile) lines.push(`- ${p.label}：${p.value}`)
    lines.push(``)
    lines.push(`## 二、推荐路线：${data.persona.title}`)
    lines.push(data.persona.blurb)
    lines.push(``)
    lines.push(`> ${data.level.hint}`)
    lines.push(``)
    lines.push(`## 三、推荐上手工具`)
    for (const a of data.agents) {
        lines.push(`- **[${a.name}](${a.url})** · ${a.org} · 新手友好 ${'★'.repeat(a.rating)}${'☆'.repeat(5 - a.rating)}`)
        lines.push(`  - ${a.tagline}`)
    }
    lines.push(``)
    lines.push(`## 四、技能树 · 聚焦分支`)
    data.skills.forEach((s, i) => {
        lines.push(`### ${i === 0 ? '【主攻】' : '【基础】'} ${s.icon} ${s.name}`)
        lines.push(`_${s.subtitle}_`)
        for (const it of s.items) lines.push(`- ${it}`)
        lines.push(``)
    })
    lines.push(`## 五、开源学习项目`)
    for (const p of data.projects) {
        lines.push(`- **[${p.name}](${p.url})** · \`${p.slug}\` · ★ ${p.stars}`)
        lines.push(`  - ${p.desc}`)
    }
    lines.push(``)
    lines.push(`## 六、${data.template.title}`)
    lines.push('```')
    lines.push(data.template.body)
    lines.push('```')
    lines.push(``)
    lines.push(`## 七、${data.persona.tag} 常见避坑`)
    for (const p of data.pitfalls) lines.push(`- ${p}`)
    lines.push(``)
    if (data.fastWin) {
        lines.push(`## · 第一小时速胜：${data.fastWin.title}`)
        data.fastWin.steps.forEach((s, i) => lines.push(`${i + 1}. ${s}`))
        lines.push(``)
        lines.push(`> 预期：${data.fastWin.expect}`)
        lines.push(``)
    }
    if (data.fourWeekPlan) {
        lines.push(`## · 4 周入门计划（${data.persona.tag}版本）`)
        data.fourWeekPlan.forEach(w => {
            lines.push(`### 第 ${w.week} 周 · ${w.focus}`)
            for (const t of w.tasks) lines.push(`- ${t}`)
            lines.push(``)
        })
    }
    if (data.ladder) {
        lines.push(`## · 生产力阶梯`)
        for (const s of data.ladder) lines.push(`- **${s.stage} · ${s.name}** — ${s.sign}`)
        lines.push(``)
    }
    if (data.concepts) {
        lines.push(`## · 必懂 ${data.concepts.length} 个关键概念`)
        for (const c of data.concepts) lines.push(`- **${c.term}**：${c.gloss}`)
        lines.push(``)
    }
    if (data.modelSnapshot) {
        lines.push(`## · 2026 Q2 主流模型快照`)
        for (const m of data.modelSnapshot) lines.push(`- **${m.name}**（${m.org}）— ${m.strength}`)
        lines.push(``)
    }
    if (data.aiPrimer && data.aiPrimer.length) {
        lines.push(`## · AI 原理科普 · ${data.aiPrimer.length} 个核心概念`)
        lines.push(`> 这是本报告的"扫盲章"——读完这一节，你就能听懂 AI 圈 90% 的术语。`)
        lines.push(``)
        for (const p of data.aiPrimer) {
            lines.push(`### ${p.emoji} ${p.term}`)
            lines.push(`> ${p.analogy}`)
            lines.push(``)
            lines.push(p.body)
            lines.push(``)
            lines.push(`**常见误区**：${p.misconception}`)
            lines.push(``)
        }
    }
    if (data.techMap && data.techMap.length) {
        lines.push(`## · 2026 AI 技术全景图（五层）`)
        lines.push(`> 想知道一件事用谁做？先到对应的层，再看"何时选谁"。`)
        lines.push(``)
        for (const layer of data.techMap) {
            lines.push(`### ${layer.emoji} ${layer.layer}`)
            lines.push(`_${layer.oneLiner}_`)
            for (const r of layer.rows) lines.push(`- **${r.name}** — ${r.when}`)
            lines.push(``)
        }
    }
    if (data.learningPath) {
        const lp = data.learningPath
        lines.push(`## · 学习路径 · 30 / 60 / 90 天`)
        lines.push(`### 里程碑`)
        for (const m of lp.milestones) {
            lines.push(`- **${m.at}** · ${m.goal}`)
            lines.push(`  - 信号：${m.signal}`)
        }
        lines.push(``)
        lines.push(`### 免费资源池（按读完性价比排）`)
        for (const g of lp.free) {
            lines.push(`#### ${g.kind}`)
            for (const it of g.items) lines.push(`- [${it.name}](${it.url}) — ${it.tip}`)
            lines.push(``)
        }
        lines.push(`### 长期练习习惯`)
        for (const p of lp.practice) lines.push(`- ${p}`)
        lines.push(``)
    }
    if (data.timePlan || data.blocker || data.horizon) {
        lines.push(`## 八、深度定制建议`)
        if (data.timePlan) {
            lines.push(`### 学习节奏 · ${data.timePlan.budget}`)
            for (const s of data.timePlan.plan) lines.push(`- ${s}`)
        }
        if (data.blocker) {
            lines.push(`### 破障点：${data.blocker.title}`)
            lines.push(data.blocker.tip)
        }
        if (data.horizon) {
            lines.push(`### 半年目标：${data.horizon.title}`)
            for (const s of data.horizon.steps) lines.push(`- ${s}`)
        }
        lines.push(``)
    }
    if (data.freeText) {
        lines.push(`## 九、你自己的话`)
        lines.push('> ' + data.freeText.replace(/\n/g, '\n> '))
        lines.push(``)
    }
    lines.push(`## 十、${data.tip.emoji} ${data.tip.title}`)
    lines.push(data.tip.body)
    lines.push(``)
    lines.push(`## 十一、下一步行动`)
    data.steps.forEach((s, i) => lines.push(`${i + 1}. ${s}`))
    lines.push(``)
    lines.push(`---`)
    lines.push(`> 报告由 ADu Helper AI 入门导航生成。下次进入时输入编号 \`${id}\` 可继续完善。`)
    return lines.join('\n')
}
